const messages = {
  paidOut: "(Uitbetaald)",
  product: "Product",
  quantity: "Aantal",
  attributes: "Kenmerken",
  points: "Punten",
  point: "Punt",
  action: "Actie",
  clear: "Verwijderen",
  back: "Terug",
  save: "Speichern",
  close: "Sluiten",
  of: "Van",
  to: "Naar",
  copyrights: "© {date} Bridgestone",
  pageNotFound: "Pagina niet gevonden",
  accessDenied: "Toegang geweigerd",
  search: "Zoek",
  dashboard: {
    profile: {
      welcome: "Welkom",
      completeProfile: "Vul uw persoonlijke profiel in en verdien",
      completeProfileBold: "25 extra punten.",
      link: "Profiel tonen",
      fullCompleteProfile: "Je persoonlijke profiel is compleet! ",
    },
    pobox: {
      newMessages: "Nieuwe berichten in uw inbox",
      link: "inbox openen",
    },
    bankstatement: {
      yourScore: "Uw huidige aantal marketingpunten:",
      lastUpdate: "Laatste update:",
      link: "Overzicht puntensaldo",
      kickbackLink: "Overzicht bonus",
      yourKickback: "Uw huidige bonus",
    },
    showAllProducts:
      "Naar de Bridgestone <span class='text-danger'>Plus</span> shop",
  },
  pageName: {
    productInfoAndQuestions: "Prijslijsten",
    preislisten: "Prijslijsten",
    preislistenList: "Prijslijsten",
    dashboard: "Home",
    trainings: "Training",
    onlineTrainings: "Online training",
    bridgestoneSchulungen: "Bridgestone-opleiding",
    shop: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    shopProducts: "Bridgestone <span class='text-danger'>Plus</span> Shop",
    shopCategory: "Bridgestone <span class='text-danger'>Plus</span> Shop",
    product: "Product",
    productDetails: "Productdetails",
    productInfo: "Productinformatie",
    pkw: "Auto",
    motorrad: "Motorfiets",
    lkwUndBusse: "Vrachtwagens en bussen",
    produktbroschuren: "Productbrochures",
    pricat: "Prikaat",
    landwirtschaft: "Landbouw",
    baumaschinenOtr: "Bouwmachines - Otr",
    bDrive: "Afbeeldingen en logo's van banden",
    beanstandungsFormular: "Klachten formulier",
    bridgestoneProduktbroschuren: "Bridgestone-producten",
    firestoneProduktbroschuren: "Firestone-producten",
    technologien: "Technologieën, markeringen en meer",
    training: "Training",
    trainingForm: "Trainingsformulier",
    account: "Mijn BRIDGESTONE <span class='text-danger'>PLUS</span>",
    pointsOverview: "Mijn bandenbestellingen",
    stammdaten: "Mijn Profiel",
    mailbox: "Inbox",
    singleMailbox: "Nieuws",
    bridgestoneSingleSchulungen: "Bridgestone-trainingen",
    externeTraining: "Externe training",
    warenkorb: "Winkelmand",
    orderSummary: "Besteloverzicht",
    orderDelivery: "Bezorgadres",
    orderComplete: "Bestelling succesvol",
    text_page: "Statische pagina",
    contact_service: "Contact & Service",
    sales_support: "Verkoopondersteuning",
    salesPromotions: "Verkooppromotie",
    productInfoAndPriceList: "Productinformatie & prijslijsten",
    service_number: "Servicenummers",
    about: "Over BRIDGESTONE PLUS",
    contact_form: "Klachten formulier",
    userOrders: "Mijn bestellingen",
    userOrder: "Jouw bestelling",
    hunterShop: "Hunter",
    wholesaler: "Distributeurs-dashboard",
    news_feeds: "Huidig",
    investment: "Investeringssteun",
    staff: "Dashboard",
    fuelCalculator: "Brandstofbesparing",
    myAccount: "Mijn Bridgestone Plus",
    myPoints: "Mijn bandenbestellingen",
    commitmentLetter: "Voorwaarden voor deelname",
    rewardsOverview: "Uitleg bonus & punten",
    strategic_partners: "Distributeurs contact",
    onlineVisibility: "Uberall",
    media: "Mediapakketten",
    first_stop: "Bridgestone bandengarantie",
    staffVouchers: "Vouchercodes",
    wholesalerVouchers: "Vouchercodes",
    brochure_prices: "Productbrochures",
    touch_incentive: "Contact Touch Incentive",
    favoriteProducts: "Favoriete producten",
    thankyou: "Bedankt",
  },
  account: {
    title: "Mijn Bridgestone <span class='text-danger'>Plus</span>",
    desc: "Hier kunt u uw gegevens aanvullen of aanpassen, uw mailbox en uw bandenbestellingen met puntenoverzicht bekijken.",
    descStaff:
      "Hier kunt u uw gegevens aanvullen of aanpassen, uw mailbox en uw bandenbestellingen met puntenoverzicht bekijken.",
    categories: {
      basedata: {
        title: "Profiel & gegevens",
        desc: "Voer hier uw contact- en bedrijfsgegevens in.",
      },
      pobox: {
        title: "Inbox",
        desc: "In uw persoonlijke mailbox vindt u belangrijk nieuws en updates.",
      },
      bankstatement: {
        title: "Bandenbestellingen & puntenoverzicht",
        desc: "Hier kunt u uw huidige bandenbestellingen en uw puntenoverzicht bekijken.",
      },
    },
  },
  profile: {
    title: "Mijn Profiel",
    description: "Hier kunt u uw gegevens aanvullen of aanpassen.",
    personalData: "Persoonsgegevens",
    password: "Wachtwoord",
    password1: "Wachtwoord (vrij te kiezen)*",
    password2: "Wachtwoord (herhalen)*",
    formOfAddress: "Aanhef",
    choose: "Kies",
    mr: "Dhr.",
    mrs: "Mevr.",
    diverse: "Verscheidene",
    firstname: "Voornaam",
    surname: "Achternaam",
    position: "Functie in het Bedrijf",
    operatingData: "Bedrijfsgegevens",
    company: "Naam bedrijf",
    legalForm: "Rechtsvorm",
    name: "Naam",
    streetHouseNr: "Straat & huisnummer",
    street: "Straat",
    postcode: "Postcode",
    location: "Plaats",
    country: "Land",
    de: "Duitsland",
    at: "Oostenrijk",
    ch: "Zwitserland",
    nl: "Nederland",
    it: "Italië",
    language: "Taal",
    french: "Frans",
    italian: "Italiaans",
    german: "Duitsland",
    nederland: "Nederland",
    phone: "Telefoon",
    website: "Website",
    operatingIndicators: "Belangrijkste operationele cijfers",
    tireSale: "Bandenverkoop per jaar alle bandenmerken",
    tireSaleLabel: "Verkoop banden in aantallen",
    inches: "≥ 18 inches (in %)",
    inchesLabel: "Waarvan 18 inch en groter in",
    segmentSale:
      "BANDENVERKOOP PER SEGMENT (aandeel Premium / Midden / Budget in %)",
    premBudget: "Premium in",
    midBudget: "Midden in",
    budBudget: "Budget in",
    distribution:
      "BANDENVERKOOP PER SEIZOEN (verdeling zomer / winter / all season in %)",
    tyreSizes: "Aantal opslagen per seizoen (bandensets)",
    diffDeliveryAddres: "Afleveradres toevoegen",
    yourEmailAddress: "Jouw e-mail adres*",
    clientNr: "Uw Klantnummers",
    clientNrSingular: "Klantnummer",
    clientNrContent:
      "<span class='text-danger fw-bold'>BELANGRIJK - LEZEN A.U.B:</span><br /><br /> Voor de toewijzing van uw bandenbestellingen bij onze distributeurs is het <b>essentieel dat uw klantnummers bij deze distributeurs gekoppeld zijn.</b> Hiernaast vindt u uw reeds gekoppelde klantnummers.<br/><br/>Bestelt u ook banden op andere klantnummers? Deze voegen wij graag voor u toe, neem hiervoor contact op met uw Bridgestone vertegenwoordiger. Kijk op de service & contact pagina voor de contactgegevens.",
    supplySource: "Distributeur",
    email: "E-mail adres",
    staffEmail: "E-mailadres deelnemer",
    registered: "Geregistreerd",
    registeredAt: "Geregistreerd op",
    lastLogIn: "Laatste aanmelding",
    salesRepresentative: "Sales Representative",
    details: "Details",
    inDetail: "{name} in detail",
    bsClientNr: "Uw Bridgestone-klantnummer",
    bftClientNr: "Uw Best4Tires-klantnummer",
    acceptTerms: "Ik accepteer de algemene voorwaarden.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>BELANGRIJK - LEZEN A.U.B:</span><br />Het kan tot 5 werkdagen duren om de klantnummer(s) te activeren en aan uw profiel te koppelen.",
    selectWholeSaler: "Kies hier de distributeur",
    cooperation: "LID / SAMENWERKING",
    error100: "De som van de waarden moet 100% zijn.",
    errorRange: "De waarde moet tussen 0 en 100 liggen",
    btw_number_label: "Bijvoorbeeld: NL123456789B01",
    btw_number: "BTW-nummer",
    mobile: "(MOBIEL) TELEFOONNUMMER",
    mobile_label: "Uw (mobiel) telefoonnummer",
    iban_number: "IBAN-nummer VAN UW BEDRIJF",
    iban_number_label: "Bijvoorbeeld: NL91ABNA0417164300",
    yourCsNr: "Uw klantnummers",
    yourLastName: "Uw achternaam",
    positionLabel: "Functie binnen het bedrijf",
    yourFirstName: "Uw voornaam",
    companyLabel: "Bedrijf",
    numberOfSetsOfSeasonalTiresBudget: "Opslag per jaar",
    tireSaleDetail: "Bandenverkoop per jaar",
    contactInfo: "Als u vragen heeft, kunt u contact opnemen met:",
  },
  pobox: {
    title: "Inbox",
    desc: "Belangrijke berichten, marketingacties en nieuws vindt u hier in uw persoonlijke mailbox.",
    message: {
      sender: "Afzender",
      thread: "Onderwerp",
    },
    sender: {
      system: "BRIDGESTONE PLUS",
    },
    back: "Terug naar het overzicht",
  },
  time: {
    secondsAgo: "{time} seconden geleden",
    minutesAgo: "{time} minuten geleden",
    hoursAgo: "{time} uur geleden",
    daysAgo: "{time} dagen geleden",
  },
  bankstatement: {
    title: "Mijn bandenbestellingen",
    desc: "Uw puntensaldo en uw bonus worden 1x per dag bijgewerkt met een vertraging tot 5 dagen in de verkoopdata.<br/>Indien u een vouchercode heeft, kunt u deze code hieronder invoeren en omwisselen naar marketingpunten. De marketingpunten zijn na het toevoegen direct zichtbaar in uw puntensaldo.",
    score: "Puntensaldo",
    regularPoints: "Reguliere punten",
    boosterPoints: "Boosterpunten",
    date: "Datum",
    supplySourceReason: "Distributeur / Bridgestone PLUS",
    article: "Artikel",
    brand: "Merk",
    product: "Product",
    type: "Type",
    inch: "Banden-maat",
    season: "Seizoen",
    amount: "Aantal",
    standardPoints: "Punten",
    boosterProduct: "Boosterproduct",
    boosterSeason: "Boosterseizoen",
    otherActions: "Activiteit",
    totalPoints: "Totaal aantal punten",
    income: "Punten toegevoegd in",
    kickbackIncome: "Bonus toegevoegd in",
    spending: "Overzicht",
    lastMonth: "huidige status",
    loadMore: "Meer",
    typeFilter: "Filter op distributeur",
    dateFilter: "Filter op datum",
    customer_number: "Klantnr.",
    currentPoints: "Overzicht",
    calculationDate: "Berekeningsdatum",
    positivePoints: "Verdiende punten",
    negativePoints: "Reeds uitgegeven",
    tyresAmount: "Bandenaantal",
    pointsTotal: "Totaal aantal punten",
    currentPointState: "Actueel puntensaldo",
    currentKickbackState: "Actueel bonus",
  },
  shop: {
    variant: "Varianten selecteerbaar",
    description:
      "Welkom in de Bridgestone PLUS Shop.<br/>Hier kunt u uw marketingpunten inwisselen voor mooie geschenken uit verschillende categorieën. Het assortiment wordt regelmatig bijgewerkt. Veel plezier bij het maken van uw keuze!<br/><br/>Heeft u een vraag? Bezoek dan onze Contact & Service pagina of <a href='/contact' class='text-danger'>klik hier</a>.",
    selectedProducts: "Geselecteerde producten",
    selectedAddress: "Geselecteerd adres",
    noProducts: "De zoekcriteria leverden geen treffers op",
    placeOrder: "BEVESTIG UW BESTELLING",
    toOrderDelivery: "Ga verder naar het afleveradres",
    toOrderSummary: "Verder naar bestellen",
    emptyCart: "Winkelwagen is leeg.",
    pointsTotal: "Puntentotaal",
    productImg: "Product afbeelding",
    selectAddressBtn: "Kies adres",
    selectAddressP: "Selecteer uw afleveradres",
    notEnoughPoints:
      "U heeft onvoldoende marketing punten om dit item toe te voegen aan uw winkelmand.",
    outOfStock: "Momenteel niet op voorraad",
    timeUnavailable: "Momenteel niet beschikbaar op dat moment",
    cart: {
      pointsPerUnit: "Punten/eenheid",
      pointsSum: "Punten",
    },
    sort: {
      asc: "Sorteren op laagste prijs",
      desc: "Sorteren op hoogste prijs",
    },
    perPgae: "Items per pagina",
    categories: {
      advertising: {
        title: "Reclamemateriaal",
        desc: "Neem direct deel hier op het platform en verzamel <br /> 40 extra punten voor de beloningsclub.",
      },
      rewards: {
        title: "Exclusieve beloningen",
        desc: "Ontdek het bonusaanbod in ons trainingscentrum of bij u op locatie.",
      },
      tools: {
        title: "Werkplaats gereedschap",
        desc: "Gebruik uw punten voor <br /> trainingen van derden en verlaag uw kosten.",
      },
      trainings: {
        title: "Training & onderwijs",
        desc: "Ontdek het bonusaanbod in ons trainingscentrum of bij u op locatie.",
      },
      salesroom: {
        title: "Verkoopruimte",
        desc: "Richt de verkoopruimte in en bied uw klanten een aangenaam verblijf.",
      },
      hunter: {
        title: "Hunter",
        desc: "Inruilpunten voor aantrekkelijke werkplaatsinrichting van Hunter.",
      },
    },
    bestSold: "Meest verkocht",
    seasonal: "Seizoensgebonden",
    affordable: "Ontdek",
    forPoints: "{points} punten",
    reachedPoints: "Voldoende punten beschikbaar",
    cartRemainPoints: "Resterende punten",
    remainingPoints: "Nog {points} punten nodig",
  },
  externeTraining: {
    title: "Externe training",
    description:
      "Ontvang deskundige kennis en, als u de betreffende trainingstests met succes voltooit, uw persoonlijke certificaat van deelname en een eenmalige 40 extra punten voor de beloningsclub",
    additionalInfo:
      "Naast onze gratis online trainingen en de betaalde Bridgestone trainingen bieden wij u ook de mogelijkheid om met uw spaarpunten – afhankelijk van uw tegoed – externe trainingen te financieren of te subsidiëren.",
    itsEasy: "Het is zo makkelijk:",
    excludeText:
      "Begrijp alstublieft dat aanbiedingen van directe concurrentie zijn uitgesloten.",
    downloadSection: {
      title: "Factuursjabloon downloaden",
      description1:
        "Download hier een sjabloon voor uw puntenoverzicht aan ons.",
      description2:
        "Op het voorbeeld vindt u alle informatie die u nodig heeft.",
    },
    form: {
      title: "Sollicitatie",
      thirdPartyInvoice: "Factuur van derden",
      userInvoice: "Mijn Profiel",
      bankAccountOwner: "Accounteigenaar",
      uploadInvoice: "Upload mijn factuur voor de gebruikte punten",
      have: "Ik zou graag willen",
      thirdPartyInvoiceDesc:
        "Punten in een %{calculatePriceDiscount} EUR van voor het volgende",
      userInvoiceDesc: "Gebruik trainingsfactuur, upload factuur van derden",
    },
    info: {
      paragraph1:
        " U of uw team neemt deel aan een technische training die wordt aangeboden door een externe leverancier.",
      paragraph2: "Zij verrekenen de derdenfactuur.",
      paragraph3:
        "Een aanvraag voor subsidie ​​kunt u hier op deze pagina indienen in het vragenveld",
      elements: {
        first: "Upload factuur van derden",
        second:
          "Vul het aantal punten in dat u wilt gebruiken (maximaal het bedrag van het netto factuurbedrag)",
        third:
          "U maakt voor uw bedrijf een factuur op voor het aantal gebruikte punten (0,25 EUR netto per punt) en verhoogt deze ook",
        fourth: "De facturen en de aanvraag worden gecontroleerd",
        fifth:
          "U ontvangt een uitbetaling die gelijk is aan de punten die u heeft ingezet",
      },
    },
    success: {
      title: "Bedankt",
      paragraph: {
        first: "Uw aanvraag is ontvangen.",
        second:
          "Na een positieve controle ontvangt u het bedrag van de gebruikte punten die op het opgegeven account zijn bijgeschreven, terug.",
        third: "Verificatie en betaling kunnen tot 6 weken duren.",
        fourth:
          "Wij hebben uw puntenrekening verlaagd met het aantal gebruikte punten.",
        fifth: "Een kopie van de aanvraag vindt u in uw",
      },
    },
  },
  buttons: {
    toSearch: "Zoek",
    sendRequest: "Verzend verzoek",
    formButton: "naar het formulier",
    discoverButton: "Ontdekken",
    sendButton: "Opslaan",
    makeContact: "Stuur een e-mail",
    userProfile: "Naar uw gegevens",
    userOrders: "Naar uw bestellingen",
    mailbox: "Naar uw inbox",
    pointsList: "Naar het puntenoverzicht",
    next: "DOORGAAN",
    back: "TERUG",
    skip: "Skip",
    toTheBasket: "In het winkelmandje",
    edit: "Bewerking",
    cancel: "Annuleren",
    select: "Kiezen",
    newOrder: "Nieuwe bestelling",
    downloadAll: "Download alles",
    readNow: "Lees nu",
    toDashboard: "Naar de startpagina",
    moreCustomerNumbers: "+ EXTRA KLANTNR. OPGEVEN",
    toProductInfo: "ONTDEK PRODUCTINFORMATIE",
    toAccount: "NAAR DE PUNTENACCOUNT",
    toSalesPromotions: "REGISTREER NU UW BEDRIJF",
    show: "ONTDEK NU",
    toOnlineTrainings: "NAAR DE ONLINE TRAININGEN",
    newAddress: "MAAK EEN NIEUW AFLEVERADRES AAN",
    toQuiz: "Naar de quiz",
    toDownload: "Naar Downloads",
    calculate: "Berekenen",
    reset: "Opnieuw instellen",
    register: "Aanmelden",
    refuseBtn: "WEIGEREN",
    acceptBtn: "ACCEPTEER",
    toCommitmentLetter: "NAAR Voorwaarden voor deelname",
    toKickbackFeeInfo: "NAAR UITLEG BONUS EN PUNTEN",
    clickHere: "klik hier",
    directBuy: "Bestel direct",
    toDiscover: "Ontdekken",
    dealerInfoDownload: "DOWNLOAD DEALERINFORMATIE",
    all: "Alles tonen",
    selectAll: "Selecteer alles",
    deselectAll: "Verwijder selectie",
    downloadSelection: "Download selectie",
    preview: "Voorbeeld",
    exchangeKickback: "BONUS INWISSELEN VOOR MARKETINGPUNTEN",
    convert: "Omzetten",
    vouchers: "Naar het puntenoverzicht",
    exchangeVoucher: "Vouchercode inwisselen",
    confirm: "BEVESTIGEN",
    clearFilters: "Filter resetten",
    toFavorites: "Naar uw favoriete producten",
  },
  myAccount: "Jouw rekening",
  menu: {
    account: "Mijn Profiel",
    plus: 'Over Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Verkoopondersteuning",
    mailbox: "Inbox",
    about: "Over BRIDGESTONE PLUS",
    trainingAndCourses: "Training & onderwijs",
    externalTraining: "Externe training",
    productInfo: "Productinformatie",
    productBrochures: "Productbrochures",
    priceLists: "Prijslijst",
    price: "Prikaat",
    complaintForm: "Klachten formulier",
    sales_support: "Verkoopondersteuning",
    contact_service: "Contact & Service",
    logOut: "Afmelden",
    news: "Huidig",
  },
  productInfo: {
    categories: {
      info: "Productinformatie",
      priceList: "Prijslijst",
      contact: "Contact",
    },
    page: {
      description:
        "Welkom bij het informatiegedeelte over Bridgestone & Fisrestone-producten.<br />Hier vindt u actuele brochures en prijslijsten, evenals nuttige links en formulieren.",
    },
    index: {
      title: "Productinformatie",
      description:
        "Wij helpen u graag met de verkoop van Bridgestone en Firestone producten.<br />Op deze pagina vindt u actuele en relevante documentatie over onze producten en technieken.",
      categories: {
        productBrochures: {
          title: "Productbrochures",
          description:
            "Hier kunt u de salestools van de nieuwste  Bridgestone en Firestone producten downloaden.",
        },
        bDrive: {
          title: "Product afbeeldingen & logo's",
          description:
            "Download via B-drive alle goedgekeurde logo's en afbeeldingen van Bridgestone en Firestone producten.",
          button: "NAAR B-DRIVE",
        },
        calculator: {
          title: "Brandstofbesparing",
          description: "Gebaseerd op EU-brandstoflabel",
        },
      },
    },
  },
  productList: {
    pkw: {
      title: "Personenwagens, 4x4/SUV en bestelwagens",
      description:
        "Download hier de actuele prijslijsten voor onze Bridgestone- en Firestone-banden: <ul> <li>Auto's, 4x4's en bestelwagens</li> </ul>",
    },
    trucksAndBuses: {
      title: "Prijslijsten voor vrachtwagens en bussen",
      description:
        "Download hier de actuele prijslijsten voor onze Bridgestone- en Firestone-banden: <ul> <li>Vrachtwagens en bussen</li> </ul>",
    },
    motorcycles: {
      title: "Prijslijsten voor motorfietsbanden",
      description:
        "Download hier de actuele prijslijsten voor onze Bridgestone-banden: <ul> <li>Motorfiets</li> </ul>",
    },
    agriculture: {
      title: "Prijslijsten voor landbouwbanden",
      description:
        "Download hier de actuele prijslijsten voor onze Bridgestone- en Firestone-banden: <ul> <li>Landbouw</li> </ul>",
    },
    constructionMachineryOtr: {
      title: "Prijslijsten voor bouwmachines/OTR-banden",
      description:
        "Download hier de actuele prijslijsten voor onze Bridgestone- en Firestone-banden: <ul><li>Bouwmachines/OTR </li></ul>",
    },
    main: {
      title: "Prijslijst",
      description:
        "Download hier de actuele prijslijsten voor onze Bridgestone- en Firestone-banden: <ul><li>Auto's, 4x4's en bestelwagens </li></ul>",
    },
    index: {
      description:
        "Welkom bij het informatiegedeelte over Bridgestone- en Firestone-producten. Hier vindt u actuele brochures, prijslijsten en Pricat-bestanden.",
    },
  },
  productBrochures: {
    desc: "Hier kunt u de salestools van de nieuwste  Bridgestone en Firestone producten downloaden en brochures over onze technologieën vinden.",
    technologiesTitle: "Technologieën, markeringen en meer",
    technologiesDesc:
      "Download hier de nieuwste brochures en flyers over onze technologieën, markeringen en meer voor auto's, SUV's en bestelwagens.",
    BDriveTitle: "Afbeeldingen en logo's",
    BDriveDesc:
      "Hier vindt u profielafbeeldingen, logo's en meer voor alle productgebieden en merken om te downloaden.",
    BDriveLinkText: "Link naar het BANDENILLUSTRATIES & LOGOS-portaal",
  },
  contact: {
    index: {
      title: "Contact & Service",
      description:
        "Wij staan voor u klaar! Hieronder vindt u de gegevens van uw Bridgestone contactpersonen en de vertegenwoordigers van uw regio.",
    },
    categories: {
      service: {
        description: "Contact met Bridgestone",
        short_desc:
          "Heeft u <span class='text-danger'>algemene vragen of opmerkingen</span> over Bridgestone PLUS, onze services of onze producten? Klikdan hieronder voor onze contactgegevens.",
      },
      contact: {
        short_desc:
          "Heeft u <span class='text-danger'>algemene vragen of opmerkingen</span> over Bridgestone PLUS, onze services of onze producten? Klik dan hieronder voor onze contactgevens",
      },
      form: {
        description:
          "Dien productklachten hier rechtstreeks in via het formulier",
      },
      touch: {
        title: "Contact Touch Incentive",
        description:
          "Heeft u een probleem met uw <span class='text-danger'>bestelling in de Bridgestone PLUS Gift Shop? (geen bandenbestellingen)</span> Hier vindt u de contactgegevens van de leverancier.",
        desc: "Heeft u een probleem met uw bestelling in de Bridgestone PLUS Gift Shop? (geen bandenbestellingen) Hier vindt u de contactgegevens van de leverancier.",
        content:
          "Indien u vragen heeft over de producten in de Bridgestone PLUS Shop, geplaatste bestellingen, levertijden of leveringen, neem dan alstublieft rechtstreeks contact op met onze leverancier: Touch Incentive Rotterdam - 010 2043075 - support&#64;touchincentive.com.",
      },
    },
    form: {
      intermediaryAddress: "Adres tussenpersoon",
      nameFirma: "Naam/Bedrijf",
      strHouseNr: "Je Straat",
      contactPerson: "Contactpersoon",
      vehicleDetails: "Informatie over het voertuig",
      vehicleTyres: "Voertuig/banden*",
      brandNew: "Gloednieuw (niet gemonteerd)",
      newItem: "Nieuw (gemonteerd)",
      fwd: "Voorwielaandrijving",
      rwd: "Achterwielaandrijving",
      awd: "Vierwielaandrijving",
      vehicleManufacturer: "Voertuigfabrikant",
      vehicleModelType: "Voertuigmodel en typeaanduiding volgens goedkeuring",
      firstRegistration: "Eerste registratie",
      enginePower: "Motorvermogen (KW bijv. 150)",
      originalEquipment: "Originele uitrusting",
      tireMilageHours: "Kilometerstand (km) / bedrijfsuren",
      tireMilage: "Kilometerstand (km)",
      tireHours: "Werk uren",
      milageOrHours: "Km of uren (bijv. 2000)",
      copyTire1: "Kopieer band 1",
      copyTire3: "Kopieer band 3",
      damageDetails: "Schadedetails",
      complaintReason: "Reden van klacht*",
      vibration: "Trillingen",
      notBalancable: "Kan niet in evenwicht zijn",
      sounds: "Geluiden",
      airPressureLost: "Verlies van luchtdruk",
      worn: "Slijtage afbeelding",
      runningPerformance: "Kilometerstand",
      deformation: "Deuken/vervormingen",
      profileBreakouts: "Profieluitbraken",
      cracks: "Scheuren",
      drivingBehavior: "Rijgedrag",
      pull: "Trekken",
      wetGrip: "Natte greep",
      defective:
        'Defecte nieuwe goederen (vermeld het nummer van de leveringsbon onder "Reden voor klachttekst")',
      otherReason: "Andere reden (geef aan onder “tekst klachtreden”)",
      isTyreReplaced: "Zijn de banden al vervangen?*",
      ifYesTyre: "Zo ja, merk vervangingsbanden",
      clerkName: "Naam van de griffier*",
      conclusion: "Diploma",
      conclusionContent:
        "<p>Deze informatie is volledig en is naar ons beste weten verstrekt.<br />Het staat vast dat de geklaagde banden op het bovengenoemde<br />voertuig zijn gereden. <br /><br /><b>De banden kunnen worden doorgesneden voor testdoeleinden. </b><br /><br /><b>Als de klacht wordt aanvaard, behouden wij ons het recht voor om<br />de banden terug te betalen na een pro rata krediet, of te compenseren met<br />een gratis vervanging levering.<br /></b><br />De goedgekeurde banden worden gesloopt. Bij afwijzing kan deze teruggevraagd worden. <br /><br />Het opslaan van bovengenoemde persoonsgegevens is toegestaan.<br /></p>",
      agreementReadAccept: "Overeenkomst gelezen en geaccepteerd.*",
      termsConditionsRead: "Lees algemene voorwaarden.",
      termsConditionsReadAccept:
        "Algemene voorwaarden gelezen en geaccepteerd.*",
      send: "Opslaan",
      requiredField: "*Verplicht veld",
      tires: "Banden",
      tirePosition: "Positie van de banden",
      notKnown: "Niet bekend",
      carSUVTractor: "AUTO/SUV/TRACTOR",
      CSTFrontLeft: "P/S/T-linksvoor",
      CSTFrontRight: "P/S/T-rechtsvoor",
      CSTRearLeft: "P/S/T-achter links",
      CSTRearRight: "P/S/T-achter rechts",
      motorcycle: "MOTORFIETS",
      motFront: "APK voorzijde",
      motRear: "APK achterzijde",
      truck: "SZM-vrachtwagen",
      truckSteeringAxle1Left: "Vrachtwagen stuuras 1 links",
      truckSteeringAxle1Right: "Vrachtwagen stuuras 1 rechts",
      truckSteeringAxle2Left: "Vrachtwagen stuuras 2 links",
      truckSteeringAxle2Right: "Vrachtwagen stuuras 2 rechts",
      truckDriveAxle1LeftInner: "Vrachtwagen aandrijfas 1 links binnen",
      truckDriveAxle1LeftOuter: "Aandrijfas 1 vrachtwagen links buiten",
      truckDriveAxle1RightInner: "Vrachtwagen aandrijfas 1 rechts binnen",
      truckDriveAxle1RightOuter: "Vrachtwagen aandrijfas 1, rechts buiten",
      truckDriveAxle2LeftInner: "Aandrijfas 2 vrachtwagen links buiten",
      truckDriveAxle2LeftOuter: "Vrachtwagen aandrijfas 2 links binnen",
      truckDriveAxle2RightInner: "Vrachtwagen aandrijfas 2, rechts buiten",
      truckDriveAxle2RightOuter: "Vrachtwagen aandrijfas 2 rechts binnen",
      truckTrailingAxleLeft: "Sleepas van vrachtwagen aan de linkerkant",
      truckTrailingAxleRight: "Sleepas van vrachtwagen rechts",
      trailerSemi: "AANHANGWAGEN/Oplegger",
      trailerAxle1LeftOuter: "TRAILER as 1 buiten links",
      trailerAxle1LeftInner: "TRAILER as 1 links binnen",
      trailerAxle1RightOuter: "TRAILER as 1 rechts buiten",
      trailerAxle1RightInner: "TRAILER as 1 rechts binnen",
      trailerAxle2LeftOuter: "TRAILER as 2 buiten links",
      trailerAxle2LeftInner: "TRAILER as 2 links binnen",
      trailerAxle2RightOuter: "TRAILER as 2 rechts buiten",
      trailerAxle2RightInner: "TRAILER as 2 rechts binnen",
      trailerAxle3LeftOuter: "TRAILER as 3 buiten links",
      trailerAxle3LeftInner: "TRAILER as 3 links binnen",
      trailerAxle3RightOuter: "TRAILER as 3 rechts buiten",
      trailerAxle3RightInner: "TRAILER as 3 rechts binnen",
      DOT: "DOT (specificeer ALLE 10-11 cijfers)",
      TruckSerialNo: "Serienummer. (alleen voor vrachtwagenbanden)",
      complaintReasonText: "Reden klachttekst",
      csNumberIfNeed: "Customer Number (if available)",
    },
    teams: {
      tyre: "Team bandenhandel",
      car: "Teamautodealer",
    },
    carDealers: {
      title: "Uw persoonlijke contactpersoon bij Bridgestone TEAM AUTOHAUS",
    },
  },
  thankyou: {
    index: {
      title: "Bedankt",
      go_to_home: "GO TO HOME PAGE",
      go_to_account: "GO TO STATEMENT OF ACCOUNT",
    },
    form_only: {
      survey_completed: "Enquête voltooid!",
      description:
        "Bedankt voor uw feedback. Bij Bridgestone willen we graag de beste producten en de beste service bieden die u helpen bij uw dagelijkse werk. Uw feedback speelt een belangrijke rol om onze diensten voortduren te kunnen verbeteren.",
      error: "Er is een fout opgetreden: ",
    },
    form_points: {
      survey_completed: "Enquête voltooid!",
      description:
        "Bedankt voor uw feedback. Bij Bridgestone willen we graag de beste producten en de beste service bieden die u helpen bij uw dagelijkse werk. Uw feedback speelt een belangrijke rol om onze diensten voortduren te kunnen verbeteren.",
      description2: "Om u te bedanken, voegen we graag ",
      description3: " punten toe aan uw account.",
    },
  },
  mainPage: {
    categories: {
      productInfo: "Productinformatie",
      salesSupport: "Verkoopondersteuning",
    },
  },
  fireStoneProducts: {
    title: "Firestone-producten",
    description:
      "Download hier de nieuwste brochures en flyers over onze Firestone-banden voor auto's, SUV's en bestelwagens.",
    files: {
      summer: {
        title: "VANHAWK MEERDERE SEIZOEN",
        description: "Transporter - het hele seizoen",
        date: "Productoverzicht 2021",
      },
      winter: {
        title: "WINTERHAWK 4",
        description: "Auto's, SUV's - winter",
        date: "Productoverzicht 2020",
      },
    },
  },
  complaintForm: {
    title: "Klachten formulier",
    description:
      "Vul het volgende formulier in voor klachten over onze banden:",
    sections: {
      damageType: {
        title: "soort schade",
      },
      generally: {
        title: "over het algemeen",
      },
      regulator: {
        title: "Adres bandendealer - toezichthouder",
      },
    },
    fields: {
      ordinance: "Het orderconcept van de dealer",
      pickupLocation: "Ophaalplaats",
      ifAvailable: "(indien beschikbaar)",
      companyName: "Naam (bedrijf)",
    },
  },
  salesPromotions: {
    title: "Verkooppromotie",
    desc: "Met onze verkooppromotiecampagnes voor Bridgestone en Firestone ondersteunen wij u actief in verkoopgesprekken en voorzien u van aanvullende argumenten. Als u ook voor uw bedrijf gebruik wilt maken van promoties, kunt u op deze pagina meer informatie vinden en u aanmelden om deel te nemen als handelspartner",
    bonusCampaign: {
      title:
        '<span class="font-sm">Bridgestone-bonuspromotie</span><br /><h3 class="fw-bold">RIJD<span class="text-danger">ONZE</span>BESTE</h3>',
      desc: "Als onderdeel van de DRIVE OUR BEST-campagne ontvangen klanten die bij deelnemende detailhandelaren minimaal 2 Bridgestone-premiumbanden kopen een tegoedbon van maximaal 40 euro, die kan worden ingewisseld bij aantrekkelijke partners zoals Amazon, Aral/OMV, Media Markt, REWE , Shell, Zalando en nog veel meer. <br /><br />Het bedrag van de voucher is afhankelijk van het aantal gekochte banden en hun douanemaat.",
    },
    guarantee: {
      title:
        '<span class="font-sm">Bridgestone-bandengarantie</span><br /><h3 class="fw-bold">BAND<span class="text-danger">BESCHERMEN</span></h3>',
      desc: "Drive-in schade en stoeprandschade - wat voorheen met frustratie en ergernis gepaard ging, wordt door Bridgestone sinds 2020 succesvol digitaal opgelost op dealer- en klantvriendelijke wijze met twee jaar bandengarantie.<br /><br /> br/>Afhankelijk van de leeftijd van de verzekerde Bridgestone-band ontvangt uw klant... Bij schade wordt tot 100% van de aankoopprijs van de vervangende band terugbetaald.<br /><br /> Nu nieuw vanaf 2023: Uw klanten kunnen aanspraak maken op de garantie bij aankoop van 2 of meer banden in alle inchmaten. ",
    },
    premium: {
      title:
        '<span class="font-sm">Firestone Premium & Garantie</span><br /><h3 class="fw-bold">BANDEN<span class="text-danger">HITS</span></h3>',
      desc: "Bij deelname aan de FIRESTONE TYRE HITS-campagne ontvangen kopers van minimaal 2 Firestone-banden niet alleen een bandengarantie van 24 maanden, die bijvoorbeeld stoeprand- of drive-in-schade dekt, maar ook een entertainmentvoucher van BestChoice ter waarde van maximaal 20 euro. <br /><br />Nieuw vanaf 2023: Deelname is mogelijk bij aankoop van 2 of meer auto-, SUV- of bestelwagenbanden in alle inchmaten.",
    },
    participation: {
      title: "Meld je nu aan voor deelname",
      desc: "Wilt u één of meerdere van onze campagnes in uw bedrijf implementeren? Dan kunt u hier uw deelname aanvragen. Uw bedrijf wordt geactiveerd voor de campagne(s) en u ontvangt binnen 4 weken promotiemateriaal voor uw verkoopruimte. <br /><br />Maak uw keuze:",
      success: "Bedankt, uw aanvraag is verzonden",
      bonusCampaign:
        '<span class="fw-bold">DRIVE<span class="text-danger">ONZE</span>BESTE</span> - De Bridgestone-bonuscampagne',
      guarantee:
        '<span class="fw-bold">BAND<span class="text-danger">BESCHERMEN</span></span> - Bridgestone-bandengarantie',
      advantage:
        '<span class="fw-bold">TIRES<span class="text-danger">HITS</span></span> - De Firestone premiumcampagne met extra bandengarantie',
      premium:
        '<span class="fw-bold">TIRES<span class="text-danger">HITS</span></span> - De Firestone premiumcampagne met extra bandengarantie',
      request: "Meld je aan voor deelname",
    },
  },
  trainings: {
    seasons: {
      all: "All season",
      summer: "Zomer",
      winter: "Winter",
      general: "Algemeen",
    },
    offer:
      "Wij breiden ons trainingsaanbod regelmatig uit. We informeren u hierover in uw BRIDGESTONE <span class='text-danger'>PLUS</span> inbox.",
    summary: {
      congratulations:
        "Gefeliciteerd, u hebt de producttraining {name} met succes afgerond.",
      participation:
        "U ontvangt uw certificaat per e-mail of u kunt het hier direct als PDF downloaden:",
      certificate:
        "U ontvangt uw certificaat per e-mail of u kunt het hier direct als PDF downloaden:",
      send: "Certificaat downloaden",
    },
    online: {
      title: "Online training",
      desc: "Vergroot uw kennis van de Bridgestone-producten. Als u de korte test met succes afrondt, ontvangt u 25 extra punten en een certificaat van deelname.",
      content: "Ontdek onze online trainingen en neem direct deel",
    },
    lectures: {
      title: "Bridgestone-opleiding",
      desc: "Breid uw vakkennis verder uit en boek onze intensieve trainingen, gehouden op uw eigen locatie, voor uzelf en of uw team. U kunt uw spaarpunten gebruiken voor de trainingen en de kosten geheel of gedeeltelijk verrekenen met uw punten.",
      content: "Ontdek nu onze actuele trainingen en vraag een boeking aan:",
    },
    singleLecture: {
      registerForm: {
        title: "Inhoud van de opleiding",
        inquiry: "Navraag",
        interested: "Ik ben geïnteresseerd in de opleiding",
        participantsNr: "Aantal deelnemers",
        pointsFromBalance:
          "Ik wil graag punten uit mijn puntensaldo gebruiken.",
        reduction:
          "Dit komt overeen met een besparing op de trainingskosten van {points} euro.",
        request: "Verzend verzoek",
        notEnoughPoints:
          "U heeft onvoldoende marketing punten om dit item toe te voegen aan uw winkelmand.",
      },
      success: {
        thanks: "Bedankt",
        title: "Uw aanvraag is verzonden naar het trainingsteam.",
        feedbackTime:
          "U ontvangt binnen 14 dagen feedback om alle details te verduidelijken.",
        points:
          "De gebruikte beloningspunten ter waarde van<br /><strong>{points}</strong> punten zijn afgetrokken van uw<br />puntenaccount.",
        refund:
          "Indien de training niet doorgaat, worden de punten uiteraard weer aan u bijgeschreven.",
        queries: "Als u vragen heeft, kunt u contact opnemen met:",
      },
      index: {
        costs: "Kosten en deelname-informatie",
        duration: "Duur: {duration}",
        cost: "Kosten {cost}: {price} euro ({points} points)",
        participantsNr: "Aantal deelnemers: min. {min} -max. {max} mensen",
      },
    },
    index: {
      title: "Training",
      desc: "Verzeker u en uw team van exclusieve vakkennis met ons trainingsaanbod. We bieden online trainingen waaraan u direct kunt deelnemen en waarmee u extra punten kunt verdien, of we komen naar u toe voor een product- en/of technische training.",
      online: {
        title: "Online training",
        desc: "Ontdek online training en krijg inzicht in de Bridgestone-productwereld!",
        short_desc:
          "Volg de online trainingen en ontdek de Bridgestone-producten.",
      },
      lectures: {
        title: "Training op locatie",
        desc: "Hoogwaardige trainingen op locatie.",
      },
      external: {
        title: "Externe training",
        desc: "Gebruik spaarpunten voor aanbiedingen van derden en verlaag de kosten.",
      },
    },
  },
  salesSupport: {
    title: "Verkoopondersteuning",
    desc: "Wij bieden u verschillende maatregelen en campagnes om uw verkoop actief te ondersteunen - van een sterke verkoopbevorderende campagne, een aantrekkelijke verkoopruimte tot individuele ondersteuning.",
    salesPromotions: {
      title: "Verkooppromotie",
      desc: "Aantrekkelijke voordelen en garanties voor uw klanten bij de aankoop van banden.",
    },
    displaysFurniture: {
      title: "Displays en meubilair",
      desc: "Gebruik uw spaarpunten om hoogwaardige apparatuur voor uw verkoopruimte te krijgen.",
    },
    individualSupport: {
      title: "Individuele ondersteuning",
      desc: "Verzeker individuele ondersteuning met uw spaarpunten.",
    },
  },
  serviceNumber: {
    title: "Contactpersonen en servicenummers",
    subtitle: "Uw contactpersoon bij Bridgestone ",
    description:
      "Wij staan voor u klaar! Hieronder vindt u de gegevens van uw Bridgestone contactpersonen en de vertegenwoordigers van uw regio.",
    manager: "Verkoopmanager Duitsland",
    yourCustomerService: "Uw klantenservice",
    generalCustomerService: "Algemene klantenservice",
    salesTerritory: "Verkoopgebied",
    carDealer: "Auto handelaar",
    centralEmail: "Centraal e-mailcontact",
    sales_manager: "Sales manager Nederland",
    contact_person: "Bridgestone plus contactpersoon",
    sales_representative: "Sales representative",
    key_account: "Key Account manager",
  },
  directions: {
    west: "Westen",
    north: "Noorden",
    east: "Oosten",
    south: "Zuiden",
  },
  training: {
    title: "Certificaat en {points} extra punten voor jou!",
    subtitle:
      " Ontvang uw persoonlijk certificaat van deelname en extra {points} extra punten voor de beloningsclub.",
    description:
      "En hoe? Het is simpel: voltooi de trainingstest na de video succesvol! De test verschijnt zodra je de video helemaal hebt bekeken!",
  },
  about: {
    title: "Over Bridgestone <span class='text-danger'>Plus</span>",
    description:
      "Bestel uw Bridgestone en Firestone banden bij één van de deelnemende distributeurs en profiteer van de vele voordelen van <b>BRIDGESTONE <span class='text-danger'>PLUS</span></b>.",
    sections: {
      first: {
        title: "Betrouwbare leveringen voor u en uw klanten",
      },
      second: {
        title: "Uitstekende banden in het premium- en middensegment",
      },
      third: {
        title: "Interessant puntenprogramma",
        description:
          "Uitgebreide mogelijkheden voor exclusieve winkelervaringen en uw digitale aanwezigheid op relevante touchpoints.",
        subtitle: "Onze bewezen verkooppromoties",
        pointInfo:
          "Profiteer van extra verkoopargumenten en uw klanten van spannende bonus- en meerwaardeacties.",
        numberInfo:
          "Digitale directe verwerking met uw klant – geen extra inspanning voor u!",
        subtitle2: "Sterke uitstraling met onze verkoopruimte-inrichting",
        description2:
          "Presenteer uw verkoopruimte sfeervol en bied uw klanten een aangenaam verblijf met onze modules voor balieruimtes, expositieruimtes, wacht- en buitenruimtes en digitale oplossingen!",
        description3:
          "Spaar punten en <b>promoot uw bedrijf</b>, samen met ons.",
      },
      fourth: {
        title: "ALLES OP ÉÉN PLATFORM: HET BRIDGESTONE PLUS PORTAAL",
        description:
          "Met uw persoonlijke toegang tot het online portaal heeft u direct toegang tot het diverse aanbod van BRIDGESTONE <span class='text-danger'>PLUS</span>.",
        list: {
          program: "Punten programma",
          shop: "Bridgestone <span class='text-danger'>Plus</span> Shop",
          priceList: "Prijslijst",
          productInfo: "Productinformatie",
          salePromotion: "Verkoopondersteuning",
          onlineTrainings: "Online training",
          andMore: "en nog veel meer.",
        },
        title2: "Regelmatige online trainingen",
        description2:
          "Blijf altijd op de hoogte en profiteer samen met uw team van de online trainingen van Bridgestone ",
      },
      points: {
        title:
          "Actuele online trainingen op het gebied van producten en verkoop:",
        list: {
          one: "Verkoop training",
          two: "Bandenconstructies",
          three: "Herken schadepatronen",
        },
        subtitle: "UW DEELNAME WORDT BELOOND",
        description:
          "Voor elke voltooide online training ontvang je <b>40 punten</b> en een <b>certificaat van deelname</b>!",
      },
      firstStop: {
        title: "Bridgestone bandengarantie",
        description:
          "Voorwaarden 24 maanden garantie op Bridgestone banden bij First Stop Benelux",
      },
    },
    fullPremium:
      "Bijna 80% van de verkochte Bridgestone banden heeft een <b>A-label voor grip op nat wegdek.</b>",
  },
  her: "Uw",
  seasons: {
    summer: "Zomer",
    winter: "Winter",
    all: "Alle seizoenen",
  },
  loginPage: {
    title: "Register",
    resetTitle: 'Welkom bij BRIDGESTONE <span class="text-danger">PLUS</span>',
    desc1:
      'U bent al succesvol geregistreerd op het BRIDGESTONE <span class="text-danger">PLUS</span> portaal.',
    desc2: "Vervolgens logt u in met uw E-mail adres en wachtwoord.",
    desc3: "Log in met uw E-mail adres en wachtwoord.",
    resetSubTitle: "Bent u nieuw hier?",
    resetDesc:
      "Maak dan eerst uw nieuwe gebruikersaccount aan met de functie AANMELDEN.",
    footer: "U wordt daarna automatisch ingelogd.",
    resetNewPass: "STEL NIEUW WACHTWOORD IN",
    noAccount: "Ik heb geen bankrekening",
    error: "Onjuiste inloggegevens, probeer het opnieuw!",
    logWithAzure: "Meld u aan met Azure",
  },
  maintenance: {
    title: "Onderhoudswerk!",
    desc: "Op dit moment voeren we noodzakelijke onderhoudswerkzaamheden uit aan onze servers.<br /><br />Voorlopig is de toegang tot <b>BRIDGESTONE <span class='text-danger'>PLUS</span></b> dan ook niet beschikbaar.<br /><br />Wij vragen om uw geduld en danken u voor uw begrip.<br /><br />Het Bridgestone Team",
  },
  contactPage: {
    title: "Klachten formulier",
    description:
      "Vul het volgende formulier in voor klachten over onze banden:",
    damage: "Schade",
    personalInjury: "Persoonlijk letsel",
  },
  yesText: "ja",
  noText: "nee",
  wrongFileError: "Het vereiste bestandsformaat is PDF",
  toastMessages: {
    addProduct: "Uw product is toegevoegd aan de winkelwagen.",
    addProducts: "Uw producten zijn toegevoegd aan de winkelwagen.",
    profileSaved: "Uw profielgegevens zijn opgeslagen",
    canAddProduct: "Je hebt niet genoeg punten.",
    customerNumberSaved: "Klantnummer opgeslagen",
    customerNumberExist: "Klantnummer beschikbaar",
    complaintForm:
      "Uw aanvraag is geaccepteerd. Wacht alstublieft op een antwoord",
    changeParentId:
      "U kunt de bovenliggende klantnummertak niet wijzigen als deze onderliggende klanten heeft",
    requestSent: "Zoek wordt verzonden",
    completeProfileRequired:
      "U moet uw profiel 100% voltooien om door te gaan met aankopen in de winkel.",
    accessDenied: "Toegang geweigerd",
    incomplete_address: "Adres is onvolledig. Gelieve dit na te kijken",
    waitMoment: "Wacht even",
    downloadFinished: "Downloaden voltooid",
    selectOneField: "Selecteer één veld",
    noVoucher: "Voucher is niet gevonden",
  },
  order: {
    number: "Bestelnr.",
    createdDate: "Besteld op",
    description:
      "Hier vindt u een overzicht van uw bestellingen in de BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP.",
    success:
      "Bedankt! <br/>Uw bestelling is gelukt. Binnen enkele minuten ontvangt u een orderbevestiging in uw Bridgestone PLUS inbox. Daarna ontvangt u van onze leverancier Touch Incentive de informatie betreffende de levering, een Track & Trace code, enz. <br/> <br/>Indien u vragen heeft over de producten in de Bridgestone PLUS Shop, geplaatste bestellingen, levertijden of leveringen, kunt u rechtstreeks contact opnemen met onze leverancier: Touch Incentive Rotterdam - 010 2043075 - support&#64;touchincentive.com. <br/>Voor overige vragen met betrekking tot Bridgestone kunt u contact opnemen via plus-nl&#64;bridgestone.eu of met uw Bridgestone accountmanager.",
    anyOrder: "Geen bestellingen",
    shippedAt: "Verzonden om",
    sku: "SKU",
    status: {
      created: "Gemaakt",
      confirm_order: "Bevestig bestelling",
      ready_for_shipment: "Klaar voor verzending",
      rejected: "Afgewezen",
      processed: "Verwerkt",
      shipped: "Verstuurd",
      returned: "Teruggekeerd",
      finished: "Klaar",
    },
    details: {
      title: "Bestel Details",
      description: "Nieuwe bestellingen beoordelen en beheren",
    },
    date: "Besteldatum",
    products: "Producten",
    quantity_short: "Stuks",
  },
  orders: "Bestellingen Bridgestone <span class='text-danger'>PLUS</span> shop",
  hunter: {
    title: "Hunter",
    description:
      "Hoogwaardige machines en uitrusting voor uw werkplaats zijn een investering in uw zakelijk succes. Gebruik uw BRIDGESTONE <span class='text-danger'>PLUS</span>-beloningspunten om de aanschafkosten van HUNTER-werkplaatsmachines te verlagen. De spaarpunten die u gebruikt, worden rechtstreeks aan HUNTER in rekening gebracht en hebben dus invloed op de aankoopprijs.",
    priceInfo: "Nettoprijs inclusief vracht en inbedrijfstelling/instructie",
    pointsInfo: "Nettoprijs in punten",
    investInfo:
      "Punten kunnen worden afgetrokken of gecrediteerd via investeringssteun.",
    contactInfo:
      "Heeft u vragen over de procedure, neem dan persoonlijk contact met ons op. Contact",
    specification: "Specificaties",
    pointDiscount: "Dit komt overeen met {price} EURO",
    form: {
      title: "Ik ben geïnteresseerd in",
      subtitle: "Ik wil graag punten uit mijn puntensaldo gebruiken",
      description:
        "Na uw aanvraag nemen wij contact met u op. Uiteraard staan ​​wij ook te allen tijde klaar om al uw vragen te beantwoorden.",
    },
  },
  intro: {
    step1: {
      title: "GEPERSONALISEERD",
      description:
        "Hier vindt u uw Bridgestone PLUS-account en uw mailbox. Via de mailbox brengen wij u op de op de hoogte over alle ontwikkelingen omtrent Bridgestone PLUS.<br/>In deze tabel ziet u hoeveel banden u heeft ingekocht bij de aangesloten distributeurs. Ook kunt u hier het minimale aantal banden per jaar voor de uitkering van de bonus vinden.",
    },
    step2: {
      title: "PUNTENSALDO",
      description:
        "Hier vindt u uw puntensaldo. <br />U kunt punten verdienen middels uw Bridgestone aankopen bij geselecteerde distributeurs. Deze punten kunt u in een later stadium verzilveren in de shop (coming soon).",
    },
    step3: {
      title: "bonus",
      description: "Hier ziet u de status van uw opgebouwde bonus.",
    },
    step4: {
      title: "BLIJF OP DE HOOGTE",
      description:
        "Blijf op de hoogte van alles omtrent Bridgestone PLUS, Bridgestone producten, nieuws en (marketing)acties.",
    },
  },
  wholesaler: {
    dashboard: {
      title: "{name} dashboard",
      extraTitle: "DISTRIBUTEURS-DASHBOARD",
      description:
        "Welkom in uw dashboard. Hier kunt u actuele cijfers en deelnemende bedrijven uit uw klantenbestand bekijken.",
      overview: {
        title: "Overzicht van deelnemende klanten",
        description:
          "Bedrijven die zich bij BRIDGESTONE <span class='text-danger'>PLUS</span> hebben geregistreerd en die wij via het klantnummer aan u kunnen toewijzen.",
        month: "Aangemaakt voor BS Plus",
        year: "Geregistreerd in BS Plus",
        all: "Totaal",
      },
      credits: {
        title: "Marketingpunten overzicht",
        description:
          "Marketingpunten worden toegekend aan deelnemende bedrijven op basis van de verkoopcijfers die u hebt geüpload.",
        prev_month: "Vorige maand",
        month: "Huidige maand",
        year: "Totaal huidig jaar gespaard",
        yearTyre: "Totaal huidig jaar gekocht",
        prev_year: "Totaal vorig jaar gespaard",
        prev_yearTyre: "Totaal vorig jaar gekocht",
        allDealers: "Alle dealerpunten",
        all: "Totaal",
      },
      details: {
        title: "Deelnemende klanten in detail",
        description:
          "Hieronder vindt u de bedrijven die zich hebben geregistreed op BRIDGESTONE <span class='text-danger'>PLUS</span> met een klantnummer van uw bedrijf.  U kunt kiezen voor een andere sortering of de zoekfunctie gebruiken om klanten op te zoeken.",
      },
      lastImport:
        "Een vertraging tot 5 dagen in de verkoopcijfers <span class='text-danger'>{date}</span>",
      loadMore: "Meer tonen",
      tyres: {
        title: "Banden",
        description: "Banden gekocht door deelnemers aan het programma",
      },
      reload: "Vernieuwen",
    },
  },
  staff: {
    dashboard: {
      title: "Dashboard",
      description:
        "Welkom in uw dashboard. Hier kunt u actuele cijfers en deelnemende bedrijven uit uw klantenbestand bekijken.",
      overview: {
        title: "Overzicht van deelnemende klanten",
        description:
          'Bedrijven die zich bij BRIDGESTONE <span class="text-danger">PLUS</span> hebben geregistreerd en die wij via het klantnummer aan u kunnen toewijzen.',
        month: "Aangemaakt voor BS Plus",
        year: "Geregistreerd in BS Plus",
        all: "Totaal",
      },
      credits: {
        title: "Overzicht Marketingpunten",
        description:
          "Marketingpunten worden toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
        prev_month: "Vorige maand",
        month: "Huidige maand",
        year: "Totaal huidig jaar gespaard",
        yearTyre: "Totaal huidig jaar gekocht",
        prev_year: "Totaal vorig jaar gespaard",
        prev_yearTyre: "Totaal vorig jaar gekocht",
        allDealers: "Alle dealerpunten",
        allPoints: "Alle punten",
      },
      details: {
        title: "Deelnemende klanten in detail",
        description:
          'Hieronder vindt u de bedrijven die zich hebben geregistreerd met een Bridgestone klantnummer op BRIDGESTONE <span class="text-danger">PLUS</span> en die aan u zijn toegewezen. Gebruik de sorteerfuncties of de zoekfunctie om specifieker te zoeken.<br/><br/><b>Opmerking: klik op de naam van de klant om naar het gedetaileerde overzicht te gaan</b>',
      },
      lastImport:
        "Een vertraging tot 5 dagen in de verkoopcijfers <span class='text-danger'>{date}</span>",
      kickback: {
        description:
          "Bonus wordt toegekend aan deelnemende bedrijven op basis van ingediende verkoopcijfers.",
      },
      tyres: {
        title: "Banden",
        description: "Banden gekocht door deelnemers aan het programma",
      },
      reload: "Vernieuwen",
      exports: {
        title: "Geëxporteerde Excels",
        head: {
          name: "Naam",
          status: "Status",
        },
      },
    },
  },
  newsFeed: {
    more: "Meer informatie op",
  },
  investment: {
    title: "Investeringssteun",
    description:
      "Bridgestone ondersteunt u ook individueel bij uw zakelijke investeringen. Ongeacht of u machines of werkplaatsuitrusting aanschaft, vervangende werkplaatsvoertuigen of marketingactiviteiten zoals het plaatsen van advertenties of online banners, enz. - gebruik uw BRIDGESTONE PLUS spaarpunten om uw investeringen te herfinancieren. Nadat u heeft geïnvesteerd, dient u hier eenvoudig de factuur van de betreffende aanbieder in en geeft u hier aan hoeveel van uw spaarpunten u wilt gebruiken. Volg de hieronder beschreven instructies.",
    description_old:
      "Investeringssteun voor werkplaatsuitrusting, reclamesubsidie ​​voor marketingprojecten",
    info: {
      paragraph2_old:
        "Zorg ervoor dat uw werkplaatsuitrusting of verkoopruimte up-to-date is of maak reclame om uw producten beter op de markt te brengen. Vertel ons hoeveel punten u voor deze bonus wilt betalen. De minimale punteneis bedraagt ​​1.250 punten, waarde per punt = € 0,25",
      paragraph2:
        "U voert uw gewenste investering uit en rekent de derdenfactuur af.",
      paragraph3_old:
        "Om de premie te kunnen factureren hebben wij uw factuur nodig voor het aantal behaalde punten (aantal punten x € 0,25 = netto factuurbedrag) en een kopie van de originele factuur. U vindt een voorbeeldfactuur",
      paragraph3:
        "Tenslotte dient u de subsidieaanvraag in het vragenveld rechts op deze pagina in",
      paragraph4_old:
        "Wij verzoeken u persoonlijk contact met ons op te nemen om de vervolgstappen te zetten.",
    },
    excludeText:
      "Begrijp alstublieft dat investeringen in aanbiedingen van directe concurrentie zijn uitgesloten.",
    here: "hier",
    contactPerson: "Contactpersoon",
    email: "E-Mail",
    phone: "Tel",
    payInfo: "Uitbetaling kan tot 8 weken duren!",
  },
  notice: "Kennisgeving",
  noticeDescription:
    "Als er sprake is van schade aan eigendommen en/of persoonlijk letsel, neem dan rechtstreeks contact op met de vestiging van Bridgestone Europe NV/SA Duitsland Tel.: 0049-6172-408-435, E-mail: <a href='mailto:{email}'>{ email} </a>, aangezien deze onderworpen zijn aan een afzonderlijke verwerking.",
  yourEmail: "Jouw E-mail adres",
  addressEndCustomer: "Adres van eindklant",
  tireSizeExample: "Bandenmaat (bijv. 215/60/16)",
  profileDesignation:
    "Profielaanduiding incl. Specificatie (bijvoorbeeld: RE050A, R168 Eco, ...)",
  speedLoadIndex: "Snelheids-/belastingsindex",
  restDay: "Gesloten",
  breakTimes: "Pauze",
  claimFrom: {
    pdf: {
      number: "Formuliernr",
      tireSizeExample: "Wielgrootte",
      dot: "PUNT",
      vehicleModelType: "Voertuigmodel/type",
      enginePower: "Motorvermogen (KW)",
      speedLoadIndex: "Snelheidsindex",
      profile: "Profiel",
      damage: "Schade",
      replacementStamp: "Vervangingsmerk",
      personalInjury: "Persoonlijk letsel",
      tiresReplaced: "Banden vervangen",
      agb: "Voorwaarden",
      clerkName: "Naam van de griffier",
      complaintReason: "Reden van klacht",
      complaintReasonText: "Reden klachttekst",
      vehicleTyres: "Voertuig/banden",
    },
  },
  fuelCalculator: {
    oldLabel: "Oud rrc-label",
    selectOldLabel: "Selecteer labelwaarde",
    tyreLife: "Totaal aantal kilometers (van de bandenset IN KM)",
    tyreLifeLabel: "Voer de totale kilometerstand in, bijvoorbeeld 40.000",
    fuelPrice: "Brandstofprijs (per liter IN EUR)",
    fuelPriceLabel: "Brandstofprijs invoeren, b.v. B. 1,82",
    newLabel: "Nieuw rrc-label",
    selectNewLabel: "Selecteer labelwaarde",
    fuelConsumption:
      "Brandstofverbruik (van het voertuig per 100 km in liters)",
    fuelConsumptionLabel: "Brandstofverbruik invoeren, b.v. B. 7.8",
    table: {
      euroSave: "Besparing over de gehele looptijd",
      fuelSavePercent: "Het brandstofverbruik wordt verminderd met",
      newConsumption: "Nieuw brandstofverbruik per 100 km",
      fuelSaveLiter: "Het brandstofverbruik daalt met 100 km",
      fuelSaveTotalLiter:
        "Het brandstofverbruik neemt af over de totale looptijd",
    },
    results: "Resultaten en besparingspotentieel",
    please: "LET OP informatie onder de resultaten",
    calcHeader:
      "Voer hier de belangrijkste gegevens voor banden en voertuig in:",
    mainDesc:
      "Met de <b>Brandstofbesparingscalculator</b> kunt u eenvoudig en direct berekenen hoeveel besparing een betere rolweerstandsklasse kan opleveren voor nieuwe banden vergeleken met een slechtere klasse. Voer eenvoudig de waarden in het formulier in.<br /><br /><b>Het resultaat heeft betrekking op de totale kilometerstand en biedt u een extra sterk argument in het verkoopgesprek - adviseer de premiumbanden van Bridgestone met geoptimaliseerde rolweerstand </b><br /><br />",
    description:
      "Banden met een lage rolweerstand die goed zijn opgepompt (volgens de specificaties van de fabrikant) kunnen tot 10% brandstofbesparing opleveren. Dit levert een financiële besparing op de bedrijfskosten op of zorgt er bijvoorbeeld bij elektrische voertuigen voor dat de bestuurder kan reizen verdere afstand voordat u moet tanken of moet opladen. De rolweerstandsklasse varieert van A (meest efficiënt) tot E (minst efficiënt). Hoe hoger de energieklasse, hoe lager de rolweerstand.",
    noticeText:
      "Op basis van de gegevens van de Europese Commissie is uitgegaan van een maximale brandstofbesparing voor alle labelklassen (Label A versus Label E) van 10%. Dit is een maximale waarde, die met name vereist dat de banden rijden met de optimale luchtdruk zoals gespecificeerd door de voertuig- of bandenfabrikant (meer informatie hierover op de website van de Europese Commissie: <a href='https://commission.europa .eu /energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en'>https:// commissie.europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en</a >). Uitgaande van maximale brandstofbesparing, uitgaande van een lineaire reductie, is er per wijziging een verschil van circa 2,5% naar de eerstvolgende betere labelklasse. Dit percentage wordt door de rekenlogica afgetrokken van de opgegeven beginwaarde van het benzineverbruik. Voorbeeld: De opgegeven verbruikswaarde bedraagt ​​7,0 l per 100 km. De brandstofbesparing moet worden berekend bij het overstappen van label C naar label A. Op basis van bovenstaande logica resulteert dit in 2,5% * 2 = 5%. Rekening houdend met de opgegeven verbruikswaarde ontstaat de volgende nieuwe verbruikswaarde: 7,0 l* (100% - 5%) = 6,65 l en dus een besparing van 0,35 l/100 km.<br /><br /> Bridgestone wijst er nadrukkelijk op blijkt dat de bovengenoemde procentuele verandering een theoretische waarde is die het bovenste bereik van mogelijke brandstofbesparingen als gevolg van de rolweerstand van de band weerspiegelt. Het dient daarom slechts als benadering en zal in de praktijk niet altijd haalbaar zijn, omdat het brandstofverbruik van een voertuig (en daarmee de besparingen ervan) naast de pure rolweerstand van de band (bijvoorbeeld rijstijl, snelheid) van vele andere factoren afhangt. bandenspanning, band- en omgevingstemperatuur, luchtweerstand van het voertuig, voertuigbelading, wegomstandigheden en chassis- en voertuiginstellingen), die elkaar ook beïnvloeden. De resultaten van de uitgevoerde berekeningen vertegenwoordigen daarom slechts een niet-bindende, benaderende schatting, voor de juistheid en nauwkeurigheid waarvoor Bridgestone geen aansprakelijkheid aanvaardt.",
  },
  legalNotice: "Juridische kennisgeving",
  addCsNumber: {
    body: "Weet u zeker dat u dit klantnummer wilt opslaan? De actieblokken bewerken gegevens totdat de beheerder deze goedkeurt.",
  },
  priceDescription: "Download hier onze prijslijsten",
  pricatDescription:
    "Hier kunt u Pricat-bestanden verkrijgen voor uw goederenbeheer.",
  pricat: {
    title: "Pricat",
    description:
      "Download hier CSV- en TEXT-gegevenssets voor uw goederenbeheer, IT-systemen enz.",
  },
  fillProfile: "Vul het profiel in om het certificaat te kunnen downloaden,",
  certificate: {
    header: "CERTIFICAAT",
    atCourse: "heeft de training",
    takePart: "succesvol afgerond.",
    contains: "Inhoud van de training:",
  },
  afterTraining: {
    congratulations: "Gefeliciteerd",
    allAnswer: "Je hebt alle vragen goed beantwoord",
    points: "Je ontvangt onmiddellijk {points} op je account!",
    clickToProfile: "Klik op de link",
  },
  kickback: {
    title: "Bonus in Euro",
    word: "Bonus",
    description:
      "bonus worden toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
  },
  externalLinks: {
    tyreBuy: "Banden bestellen",
  },
  loginPageSteps: {
    welcome:
      "Welkom bij BRIDGESTONE PLUS – Bridgestone's portaal met toegevoegde waarde.",
    step1: {
      title: "Nieuw hier?",
      description:
        "Is dit de eerste keer dat u het BRIDGESTONE <span class='text-danger'>PLUS</span> portaal bezoekt?<br /><br />Registreer u dan nu!",
      actionBtn: "WORD NU LID",
    },
    step2: {
      title: "BAND<span class='text-danger'>CLUB</span>-dealer",
      description:
        "Heeft u al toegangsgegevens voor de voormalige Bridgestone TYRE<span class='text-danger'>CLUB</span>?<br /><br />Stel dan hier uw nieuwe wachtwoord in voor het e-mailadres waarmee u de TYRE< span class='text-danger'>CLUB</span>.",
      actionBtn: "STEL NIEUW WACHTWOORD IN",
    },
    step3: {
      title: "Welkom bij BRIDGESTONE <span class='text-danger'>PLUS</span>",
      description:
        "Log in met uw e-mailadres en wachtwoord.<br/><br/><br/><b>Bent u nieuw hier?</b><br/><br/>Maak dan eerst uw nieuwe gebruikersaccount aan met de functie AANMELDEN.<br/><br/>U wordt daarna automatisch ingelogd.",
      actionBtn: "AANMELDEN",
    },
    info: 'Heeft u hulp nodig? Neem dan contact met ons op: <a href="mailto:{email}">{email}</a>',
  },
  marketingModal: {
    title: "Algemene voorwaarden & voorwaarden voor deelname",
    description:
      "Na acceptatie van de 'Voorwaarden voor deelname' ontvangt u een kopie via e-mail",
    content:
      "Algemene voorwaarden van Bridgestone Europe NV/SA, Netherlands Branch, gevestigd te Nieuwe Weideweg 1 NL-6121 PD Born (Nederland) - K.v.K. 66469767 (hierna te noemen: 'Bridgestone').",
    point1Title: "Deelname",
    point1Desc:
      "De Algemene voorwaarden houden voor de deelnemer geen verplichting in om een door Bridgestone vastgesteld marktaandeel te bereiken en ze verplichten de deelnemer evenmin uitsluitend Bridgestone-banden te verkopen. <br/>Overeengekomen is dat de deelnemer vrij blijft om zijn eigen verkoopprijzen te bepalen voor banden, zonder beperkingen, ook als er aanbevelingen zijn; deze worden echter als niet-bindend beschouwd. <br/>De vereisten voor deelname aan BS PLUS die bindend zijn voor het deelnemende bedrijf waarmee de overeenkomst is gesloten (hierna te noemen: “deelnemer”). De deelnemer erkent dat toelating voor deelname aan BS PLUS gebeurt naar goeddunken van Bridgestone en dat eisen tot toelating tegen Bridgestone niet geldig zijn. De overdracht van deelnemersaccounts is uitdrukkelijk verboden, tenzij Bridgestone anders heeft aangegeven. Het is niet toegestaan een pandrecht te vestigen op het deelnemersaccount. <br/>Deelnemers zijn verantwoordelijk voor het direct bijwerken van hun online persoonsgegevens. Niet-naleving van deze verplichting kan leiden tot extra kosten, vertragingen, grotere kans op schade of het mislopen van prijzen en andere bijkomende schade.",
    point2Title: "Bonus en marketingpunten",
    point2Desc:
      "Recht op uitbetaling ontstaat wanneer de deelnemer tussen 1 april 2024 en 31 december 2024 ten minste zestig (60) banden van het merk Bridgestone voor auto's, bestelwagens, 4x4-auto's, zomer- winter- en all-seasonbanden koopt bij de geselecteerde distributeurs. Wanneer het minimumaantal per jaar niet wordt bereikt, wordt er geen bonus verleend aan de deelnemer. Vanaf 2026 ontstaat recht op uitbetaling is wanneer de deelnemer tussen 1 januari en 31 december ten minste honderdtwintig (120) banden van het merk Bridgestone voor auto's, bestelwagens, 4x4-auto's, zomer- winter- en all-seasonbanden koopt bij de geselecteerde distributeurs. <br/>Voor de berekening van marketing punten geldt de relevante boekingsperioden vanaf 2026: Januari-december van elk jaar. <br/>De Bonus en marketingpunten gelden niet voor 2A-artikelen, demobanden, niet-actieve/inactieve EAN's op de prijslijst. Ongebruikte punten uit een voorgaand jaar vervallen in maart van het jaar erop. Ongebruikte punten uit 2024 vervallen bijvoorbeeld op 1 maart 2026. <br/>De marketing punten worden aan de deelnemer uitsluitend gecrediteerd op initiatief van Bridgestone en volledig in overeenstemming met de voorwaarden die zijn vermeld in het tabblad Voorwaarden op het Bridgestone Plus-platform. Het aantal punten per type band is te vinden op het BS-platform. https://plus.bridgestone.nl ",
    point3Title: "Beloningen",
    point31Title: "Marketingpunten",
    point31Desc:
      "De deelnemer heeft een medewerker of gedelegeerde aangewezen om de beloningen namens hem te ontvangen. Deze persoon heeft toegang tot het puntenaccount van de deelnemer. <br/>Deelnemers kunnen ervoor kiezen de bijgeschreven punten in te wisselen voor aangeboden beloningen in natura en/of diensten. Uitbetaling van de contante waarde van de gespaarde punten is niet toegestaan, tenzij dit uitdrukkelijk is vermeld in het beloningssysteem. Er wordt geen rente opgebouwd op het deelnemersaccount. Punten kunnen worden ingewisseld als op het puntenaccount voldoende punten staan voor de specifieke beloning. Deelnemers hebben geen gegarandeerd recht op een bepaalde beloning en inwisseling is onder voorbehoud van beschikbaarheid. <br/>De deelnemer kan ervoor kiezen de bijgeschreven punten in te wisselen voor de aangeboden beloningen in natura en/of diensten. Uitbetaling van de contante waarde van de gespaarde punten is niet toegestaan, tenzij dit uitdrukkelijk is vermeld in het beloningssysteem. Er wordt geen rente uitgekeerd op het deelnemersaccount. De gespaarde punten kunnen worden ingewisseld als op het puntenaccount voldoende punten staan voor de specifieke beloning. Deelnemers hebben geen gegarandeerd recht op een bepaalde beloning en inwisseling is onder voorbehoud van beschikbaarheid. <br/>Bridgestone behoudt zich het recht voor overduidelijk onjuist geprijsde beloningen te corrigeren. Ingewisselde punten zijn niet overdraagbaar en kunnen niet worden geruild voor extra punten of andere beloningen. De deelnemer ontvangt direct na het plaatsen van de order een ontvangstbevestiging.  Bridgestone zal daarna direct alle relevante gegevens controleren en de beschikbaarheid van de beloning bekijken. Tenzij uitdrukkelijk anders is vermeld, blijven alle prestaties en omvang van de beloning zoals beschreven. <br/>Ingewisselde punten kunnen niet worden geruild voor punten of beloningen. De deelnemer ontvangt direct na het plaatsen van de order een ontvangstbevestiging. Bridgestone zal daarna direct alle relevante gegevens en de beschikbaarheid van de beloning controleren. Tenzij uitdrukkelijk anders is vermeld zijn alle specificaties over prestaties, afmetingen, gewicht en formaat bij benadering; deze worden uitsluitend ter indicatie opgegeven en vormen geen gegarandeerde eigenschappen. De levertijden worden aan de deelnemer afzonderlijk doorgegeven na het plaatsen van de order. In het geval dat het bestelde artikel niet beschikbaar is of niet kan worden geleverd, behoudt Bridgestone het recht de deelnemer een vergelijkbaar artikel te sturen of de order te annuleren. <br/>De marketingpunten moeten door de deelnemer uiterlijk 31 maart van het volgende jaar worden gebruikt, anders vervallen ze.",
    point32Title: "Bonus",
    point32Desc:
      "De deelnemer ontvangt bonus zodra de aangegane verplichtingen zijn bereikt bij de geselecteerde distribiteurs. <br/>De korting wordt opgebouwd wanneer de voorwaarden voor deelname zijn geaccepteerd door de deelnemer door bandenorders die mogelijk worden gemaakt door distributeurs die Bridgestone heeft aangewezen. Bridgestone of de geselecteerde dienstverlener keert de bonus eenmaal per jaar uit aan de deelnemer na een controle van de juistheid van de verzamelde gegevens en mits is voldaan aan de hiervoor vermelde verplichtingen. Deze uitkering vindt plaats in het eerste kwartaal van het volgende jaar. Voorbeeld: de korting over 2024 wordt uitbetaald in het eerste kwartaal van 2026. <br/>Dit proces verloopt automatisch na een uitgebreide beoordeling van de bandenorders van de deelnemer en de bijbehorende gegevens. De deelnemer ontvangt de bonus rechtstreeks van Bridgestone of van een geselecteerde dienstverlener. Tegelijkertijd ontvangt de deelnemer een document bestemd voor zijn boekhouding. ",
    point4Title: "PUNTENAANTAL / WACHTWOORD",
    point4Desc:
      "De punten worden geregistreerd op het nummer van de deelnemer. Klachten over de juistheid of volledigheid van het puntenaantal moeten schriftelijk worden ingediend binnen een maand nadat dit geconstateerd is. Het niet tijdig indienen van een klacht wordt beschouwd als goedkeuring van het puntenaantal. Ook na het verstrijken van de termijn kan worden verzocht om correctie van het vermelde puntenaantal als de deelnemer de onjuistheid/onvolledigheid onomstotelijk kan aantonen. De deelnemer is verantwoordelijk voor waarborging van de vertrouwelijkheid van zijn wachtwoord en wanneer hij vermoedt dat iemand anders kennis heeft gekregen van het wachtwoord of in geval van ander misbruik moet de deelnemer het wachtwoord meteen wijzigen en Bridgestone op de hoogte stellen.",
    point5Title: "GEBREKEN/TEKORTEN",
    point5Desc:
      "Gebreken in de geleverde artikelen moeten onmiddellijk schriftelijk worden gemeld. Wanneer dit niet gebeurt, gelden de wettelijke bepalingen.",
    point6Title: "BEËINDIGING",
    point6Desc:
      "Deelname aan BS PLUS is vrijwillig en deelnemers kunnen hun deelname op elk moment beëindigen door Bridgestone daarvan op de hoogte te stellen. Het is van belang erop te wijzen dat beëindiging van de deelname geen gevolgen heeft voor het inwisselen van gespaarde punten. Bridgestone behoudt het recht om een deelnemer om gegronde redenen uit te sluiten van het programma.",
    point7Title: "AANSPRAKELIJKHEID",
    point7Desc:
      "De deelnemer aanvaardt voor zijn risico alle verplichtingen in verband met zijn bedrijfsorganisatie, bijvoorbeeld met betrekking tot werkgeverschap en relaties met zelfstandigen, met inbegrip van verzekeringsverplichtingen, het juiste fiscale en administratieve beheer van het bedrijf en de naleving van de geldende regelgeving met betrekking tot milieu, veiligheid en ongevalspreventie. <br/>Behalve in geval van opzettelijk wangedrag of grove nalatigheid is Bridgestone niet aansprakelijk voor door de deelnemer veroorzaakte schade bij de uitvoering van de in de voorwaarden bedoelde activiteiten.",
    point8Title: "WIJZIGING VAN DE VOORWAARDEN VOOR DEELNAME EN BESTELLEN",
    point8Desc:
      "Bridgestone behoudt zich het recht voor het beloningssysteem stop te zetten met inachtneming van een opzegtermijn van 3 maanden; indien daarvoor een belangrijke reden bestaat ook zonder inachtneming van een opzegtermijn, mits de belangen van de deelnemer redelijk gewaarborgd zijn. Bridgestone behoudt zich ook het recht voor de voorwaarden te wijzigen of aan te vullen voor zover dit noodzakelijk is in het belang van een eenvoudigere en veiligere verwerking en met name ter voorkoming van misbruik. De deelnemer wordt van tevoren geïnformeerd over wijzigingen. Een wijziging en/of aanvulling wordt geacht te zijn goedgekeurd wanneer deze niet binnen een maand na bekendmaking wordt beëindigd of wanneer de deelnemer opnieuw gebruikmaakt van het beloningsprogramma nadat deze periode is verstreken.",
    point9Title: "VERTROUWELIJKHEID",
    point9Desc:
      "De deelnemer verbindt zich voor hemzelf en voor zijn werknemers en medewerkers om informatie van vertrouwelijke aard zoals technische informatie, advertentie- of financiële gegevens, commerciële informatie, knowhow, prijzen, kosten, administratieve gegevens, lopende en toekomstige operationele projecten, strategieën van Bridgestone of andere informatie die op het moment van bekendmaking nog niet openbaar is niet te verspreiden aan derde partijen en deze niet te gebruiken. Deze bepaling moet ook als bindend worden beschouwd gedurende de vijf jaar volgend op de beëindiging van de deelname.",
    point10Title: "GEGEVENSBESCHERMING",
    point10Desc:
      "Bridgestone, haar geselecteerde dienstverlener en de deelnemer verbinden zich tot naleving van alle verplichtingen op grond van Verordening (EU) 2016/679 van het Europees Parlement en de Raad van 27 april 2016 betreffende de “bescherming van natuurlijke personen in verband met de verwerking van persoonsgegevens en betreffende het vrije verkeer van die gegevens” (hierna: “AVG”), evenals de relevante nationale regelgeving en de maatregelen van de toezichthoudende autoriteit. Om deel te kunnen nemen aan BS PLUS moeten er verschillende persoonsgegevens worden verzameld, opgeslagen en gebruikt.Deze gegevens zijn nodig om een persoonlijk puntenaccount te openen voor de deelnemer en hem informatie over het beloningsprogramma te kunnen sturen.De vereiste gegevens voor deelname bestaan uit: bedrijfsnaam, achternaam, voornaam, functie bij het bedrijf, volledig postadres, telefoonnummer, btw- nummer, bankrekeningnummer en e- mailadres.Ten behoeve van de verwerking en uitvoering van BS PLUS worden de gegevens van de deelnemer opgeslagen en gebruikt door TAKTZEIT, Bridgestone of een dienstverlenend bedrijf dat handelt in opdracht van TAKTZEIT.Bridgestone en TAKTZEIT verbinden zich ook om de wet - en regelgeving inzake gegevensbescherming na te leven.Gegevens worden alleen aan derde partijen verstrekt als deze handelen als opdrachtnemer, bijvoorbeeld voor de verwerking van een order voor een beloning.Door deelname aan het beloningsprogramma verleent de deelnemer toestemming hiervoor door dit te bevestigen.Deze toestemming kan op elk moment schriftelijk worden ingetrokken.Na de toestemmingsverklaring ontvangt de deelnemer de desbetreffende nieuwsbrief.Afmelding voor een nieuwsbrief is op elk moment mogelijk via het menu - onderdeel 'Contact > Afmelden nieuwsbrief'",
    point11Title: "Intellectuele eigendom",
    point11Desc:
      "De deelnemer erkent en aanvaardt dat alle huidige en toekomstige intellectuele-eigendomsrechten (hierna: “IE-rechten”) met betrekking tot, inherent aan of op enige wijze verband houdend met BS Plus eigendom zijn van de Bridgestone-groep. De deelnemer mag IE-rechten uitsluiten gebruiken in verband met zijn bedrijfsactiviteiten in de vorm van de verkoop van banden en het verlenen van diensten. <br/>In- en externe projecten voor erkenning van verkooppunten moeten worden goedgekeurd door Bridgestone. Overeengekomen is dat wanneer de deelnemer van plan is de IE-rechten te gebruiken in enige vorm van communicatie met het publiek, het promotie- en advertentiemateriaal dat is voorbereid voor dit doeleinde van tevoren aan Bridgestone moet worden voorgelegd ter goedkeuring. Bridgestone heeft het recht om op elk moment door middel van een inspectie ter plaatse in het pand van de deelnemer na te gaan of de regels voor het gebruik van IE-rechten in acht zijn genomen. <br/>De deelnemer mag het gebruik van IE-rechten op geen enkele wijze overdragen en/of op andere wijze daarvan afstand doen aan derde partijen. ",
    point12Title: "SLOTBEPALINGEN",
    point121Desc:
      "Wijzigingen in of toevoegingen aan deze voorwaarden moeten schriftelijk worden vastgelegd. Dit geldt ook voor het afstand nemen van dit  schriftelijkheidsvereiste.",
    point122Desc:
      "Het Nederlandse recht is van toepassing op de uitsluiting van het Verdrag der Verenigde Naties inzake internationale koopovereenkomsten betreffende roerende zaken. Voor geschillen in verband met of als gevolg van de verbintenisbrief wijzen partijen de rechtbank te Rotterdam (Nederland) aan als het uitsluitend bevoegde gerecht.",
    point123Desc:
      "Wanneer afzonderlijke bepalingen uit deze voorwaarden niet-uitvoerbaar of strijdig met de wettelijke bepalingen heeft dit geen gevolgen voor de rest van de overeenkomst. De ongeldige bepaling wordt door de contractpartijen in onderling overleg vervangen door een bepaling die in economisch opzicht de ongeldige bepaling zo dicht mogelijk benadert op een juridisch effectieve wijze.",
    point1234Desc:
      "De voorgaande bepaling geldt dienovereenkomstig in geval van lacunes of omissies. Mondelinge overeenkomsten worden als ongeldig beschouwd en alleen de voorwaarden die zijn vermeld in de Algemene voorwaarden (AV) worden als bindend beschouwd.",
    point13Title: "RETOURBELEID",
    point13Desc:
      "De deelnemer heeft gedurende 14 dagen recht op retourzending. <br/>In dat geval moet deze zich schriftelijk wenden tot: Bridgestone Europe NV/SA Netherlands Branch, gevestigd te Nieuwe Weideweg 1 NL- 6121 PD Born (Nederland). Bridgestone verstrekt aan de deelnemer de nodige aanwijzingen voor het retourproces. De retourtermijn gaat in zodra de deelnemer de goederen ontvangt. In geval van een retourzending van een geleverd product is de koper verantwoordelijk voor de betaling van de retourkosten als de geleverde goederen overeenstemmen met de bestelde artikelen. De punten die de deelnemer heeft ingewisseld voor de beloning worden in mindering gebracht op het puntenaccount. Het recht op retourzending geldt niet voor artikelen die op maat zijn gemaakt volgens specificaties of duidelijk zijn aangepast aan persoonlijke eisen.",
  },
  commitmentLetter: {
    title: "Voorwaarden voor deelname",
    short_description: "Hier kunt u de 'Voorwaarden voor deelname' vinden.",
  },
  kickbackInfo: {
    title: "Uitleg bonus en punten",
    short_description:
      "Hier kunt u zien hoe u bonus & marketingpunten verdient.",
    description:
      "Met <b>BRIDGESTONE</b> <span class='text-danger font-bold'>PLUS</span> verdient u punten en bonus voor alle Bridgestone banden die u bestelt bij de door Bridgestone aangewezen distributeurs. Hieronder ziet u hoe u punten en bonus verdient.<br/><br/><b>Algemeen:</b> alleen geldig op de aankoop van personenwagen-, SUV/4x4 – en bestelwagenbanden<br/><br/><b>Marketingpunten:</b><ul><li>U verdient punten op elke Bridgestone personenwagen-, SUV/4x4 – en bestelwagenband en het aantal punten is afhankelijk van de inch grootte van de band. Deze punten kunt u vervolgens besteden in de BRIDGESTONE PLUS shop.</li><li>U vindt de details in de tabellen hieronder. </li></ul><b>Bonus:</b><ul><li>De bonus wordt gedurende het kalenderjaar opgebouwd via bandenorders bij de distributeurs die door Bridgestone zijn aangesteld.</li></ul><div><b>Vanaf 1 januari 2026 wordt uw trouw nog meer beloond: u kunt uw bonus verdubbelen!</b></div><ul><il>Minimale doelstelling: 120 Bridgestone- en of Firestone  personenwagen-, SUV/4x4 – en bestelwagenbanden per jaar.</li><li>Het bonusbedrag wordt berekend op het aantal Bridgestone personenwagen-, SUV/4x4 – en bestelwagenbanden</li><li>De aantallen Firestone personenwagen-, SUV/4x4 – en bestelwagenbanden tellen wel mee voor het behalen van uw doelstelling, maar hier wordt geen bonus op berekend.</li><li>Afhankelijk van het aantal aangekochte Bridgestone- en of Firestone  personenwagen-, SUV/4x4 – en bestelwagenbanden, kunt u tot 2x het bedrag van uw bonus verdienen<li>Uitbetaling van uw bonus wordt automatisch uitgevoerd na controle van de bandenorders en uw gegevens, en gebeurt in het eerste kwartaal van het volgende kalenderjaar.</li> <li>U ontvangt de bonus rechtstreeks van Bridgestone of via zijn externe partner. U ontvangt tevens een document dat geschikt is voor opname in uw financiële administratie.</li></ul><div><b>Voorbeeld van de berekening van de marketingpunten en de bonus</b></div><div>In 2026 koopt u 850 personenwagen-, SUV/4x4 – en bestelwagenbanden: 600 Bridgestone en 250 Firestone.</div><ul><li>Marketingpunten: het aantal punten wordt berekend op basis van 600 Bridgestone-banden en hangt af van de inch-grootte van de band.</li><li>Bonus: met het totaal van 850 banden, valt u binnen de categorie “zilver”.  Uw bonusbedrag berekend op 600 Bridgestone-banden wordt met 1,5 vermenigvuldigd.</li></ul>",
    tableFooter: "Voor de overige productgroepen geen bonus: TBR, MC, OTR, AG",
    withdraw: "Voor het uitbetalen van de bonus",
  },
  pause: "PAUZE TIJD",
  myProfile: "Mijn Profiel",
  tyreAmount: "Banden hoeveelheid",
  rewardsOverview: {
    titlePoints: "Marketingpunten<br/>(1 Punt = 0,25Euro)",
    titleKickback: "Bonus in Euro",
    footerPoints:
      "Voor de overige productgroepen geen marketingpunten: TBR, MC, OTR, AG",
    kickbackPoints:
      "Voor de overige productgroepen geen bonus: TBR, MC, OTR, AG",
    groupLevel: "Group Level",
  },
  group: "Netwerk",
  major: "Groep",
  customer_group: "Groep",
  strategicPartners: {
    cardTitle: "Contact met de distributeurs",
    title: "Distributeurs contact",
    description:
      "Wij staan voor u klaar! Heeft u vragen of opmerkingen over uw bandenbestellingen bij de distributeurs, neem dan rechtstreeks contact met hen op. U vindt alle contactgegevens hieronder.",
    short_desc:
      "Heeft u <span class='text-danger'>vragen over uw bandenbestellingen</span> bij de aangesloten distributeurs? Klik dan hieronder voor hun contactgegevens.",
  },
  onlineVisibility: {
    box: {
      title: "Online zichtbaarheid",
    },
    title: "Online zichtbaarheid",
    description:
      "Vergroot en beheer uw digitale zichtbaarheid op POS-niveau met UBERALL",
    category_title: "Overal abonnement - looptijd 1 jaar",
    category_description:
      "Gebruik uw spaarpunten nu om uw digitale locatiemarketing naar een hoger niveau te tillen. Met behulp van het alomtegenwoordige platform helpt Bridgestone retailpartners hun online aanwezigheid te optimaliseren om meer verkeer te genereren. En op ruim 100 platforms zoals Google, Facebook, Bing of Trustpilot.",
    content: "Profiteer nu overal van de voordelen:",
    point1: "Online zichtbaarheid optimaliseren",
    point2: "Handig beheer en controle van POS-locaties",
    point3: "Houd lokale zichtbaarheid, recensies en sociale media-inhoud bij",
    footer:
      "Bekijk de volgende video om gedetailleerde informatie te krijgen en overal een eerste indruk te krijgen.",
    period: "Termijn: 1 jaar",
    form: {
      title: "Hoe u het overal voor uw bedrijf kunt gebruiken:",
      point1: "Sluit een jaarabonnement af voor 480 punten",
      point2: "Na een interne controle ontvangt u een bevestiging",
      point3: "geen automatische verlenging",
      pointDiscount: "Punten in een {price} EUR van voor het volgende",
      howMuch: "Hoeveel punten wil je inzetten?",
    },
    uberall: {
      title: "UBERALL ABONNEMENT",
    },
  },
  media: {
    title: "Mediapakketten",
    short_description:
      "Hier vindt u gegevens voor sociale media, tv in de winkel en meer.",
    description:
      "Hier vindt u gratis afbeeldingen, video's en digitale media. Gebruik onze mediapakketten voor uw eigen aanwezigheid op sociale media, tv in de winkel of digitale advertenties.",
  },
  sortBy: {
    default: "Sorteer op",
    desc: "Sorteer op: Nieuwste",
    asc: "Sorteer op: Oudste",
    name: "Namen",
    date: "Datum",
    choiceBy: "Selectie sorteren op",
  },
  bridgestoneProductBrochures: {
    title: "Bridgestone-producten",
    description:
      "Download hier de nieuwste brochures en flyers over onze Bridgestone-banden voor auto's, SUV's en bestelwagens.",
    files: {
      desc1: "PKW, SUV - Winter",
    },
  },
  testResult: "Test resultaten",
  productOverview: "Productoverzicht",
  summary: "Samenvatting",
  information: "Informatie",
  brochure: "Brochure",
  makeChoice: "Maak hier uw keuze",
  haveQuestion: "Sie haben eine Frage?",
  contactUs: "Dann senden Sie uns gerne eine Mail an",
  at: "bij",
  tyreBox: {
    title: "Banden",
    totalAmount: "Totaal banden",
    target: "Doelstelling",
    entry: "Minimaal doel",
    minimum: "Minimale jaardoelstelling",
  },
  firstStop: {
    description:
      "Op deze pagina vindt u de garantievoorwaarden en de aangifteformulieren van de First Stop bandengarantie. Let op; vanwege de procedure aanpassing in 2024 zijn er 2 verschillende procedures op basis van de aankoopdatum van de band.",
    section1: {
      title: "Real Garant procedure (Banden aangekocht tot 29-2-2024)",
      description:
        "Voor banden welke aangekocht zijn tot 29 februari 2024 geldt de procedure via Real Garant. Hieronder kunt u de voorwaarden en het aangifteformulier downloaden",
    },
    section2: {
      title: "First Stop procedure (Banden aangekocht vanaf 1-3-2024)",
      description:
        "In de nieuwe voorwaarden worden uitsluitend de banden vergoed, de consument betaalt de kosten voor de montage en de milieubijdrage van de nieuw te monteren band, First Stop vergoed de aanschafprijs van de band.Het staat u vrij om het montage tarief te bepalen, gelieve deze op de nieuwe factuur altijd apart te vermelden.",
      footer:
        "De procedure van claimafhandeling verandert voor de rest bijna niet. Hieronder kunt u de voorwaarden, het claimformulier en de procedure downloaden.",
    },
  },
  languageSelect: {
    title:
      "Welkom bij <b>BRIDGESTONE PLUS</b> - het premium portaal van Bridgestone.",
    label: "Taal selectie",
    description: "Selecteer uw taal/ Kies uw taal/ Selecteer de taal",
  },
  current_tyres_amount: "Banden hoeveelheid",
  current_points: "Puntensaldo",
  current_kickbacks: "Bonus",
  phoneShortCut: "Tel.",
  mediaCategories: {
    products: "Producten",
    brand_and_solutions: "Merk & oplossingen",
    season_and_promotions: "Seizoen & promoties",
    format: "Formaat",
    cars_and_vans: "Personenauto, SUV, bedrijfswagen",
    truck_and_buses: "Vrachtwagen & bus",
    motorcycle: "Motorfiets",
    agriculture: "Landbouw",
    construction_machinery: "Bouwmachines",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialen",
    brochures: "Productbrochures",
    price_list: "Prijslijsten",
    materials: "Materialen",
    summer: "Zomer",
    winter: "Winter",
    all_season: "Alle seizoenen",
    promotions: "Acties",
    price: "Pricat",
    video_in_store: "Video met ondertitels",
    video_online: "Video zonder ondertitels",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Social media",
    logos: "Logo's",
    b_drive: "B-drive",
    media_library: "Producten & Media",
    media_packages: "Mediapakketten",
    season: "Seizoen",
    trucks: "Vrachtwagens",
    technology: "Technologie",
    oe: "OE",
  },
  placeholders: {
    searchMedia: "Zoekterm invoeren",
  },
  searchResults: "Zoekresultaten",
  setFilters: "Filter",
  kickbackExchange: {
    title:
      "Vul hier het bedrag in dat u wilt omzetten van bonus in marketingpunten*:",
    description: "Vul hier de de moeite waard in*:",
    disclaimer:
      "Startniveau om bonus te kunnen omzetten: minimaal {tyres} bestelde banden in {year}.",
    afterExchange: "Uw marketingpuntensaldo na de omzetting:",
    forAdd: "Het aantal punten na inwisseling:",
    error:
      "U heeft minimaal {tyres} bestelde banden per jaar nodig om uw bonus te kunnen omzetten.",
  },
  productSearchBox: {
    from: "van puntenwaarde",
    to: "tot puntwaarde",
  },
  validators: {
    min_money: "Veld moet groter zijn dan {min} €",
    max_money: "Veld moet dan lager zijn {max} €",
  },
  vouchers: {
    title: "Overzicht vouchercodes",
    short_description:
      "Hier vindt u een overzicht van de gebruikte vouchercodes.",
    table: {
      headers: {
        voucher: "Voucher codes",
        company: "Bedrijf",
        street: "Straat",
        postcode: "Postcode",
        location: "Plaats",
        solved_at: "Datun",
        points: "Aantal punten via de code",
      },
    },
    exchange: {
      title: "Vul uw code in om punten te krijgen",
      pointsLabel: "Vul hier de code in:",
      result: "Aantal punten:",
    },
  },
  subMediaPage: {
    description:
      "Welkom bij het mediagedeelte over Bridgestone- en Firestone-producten. Hier vindt u actuele productafbeeldingen, logo's en talrijke banners, video's en digitale sjablonen die u bijvoorbeeld kunt gebruiken. B. op uw website of op sociale media.",
  },
  brochure_prices: {
    description:
      "Download hier de nieuwste brochures en salestools over onze Bridgestone en Firestone banden.",
  },
  brochureCategories: {
    products: "Producten",
    brand_and_solutions: "Merk",
    season_and_promotions: "Seizoen & Promoties",
    format: "Formaat",
    cars_and_vans: "Car/bestelwagens",
    truck_and_buses: "Vrachtwagens en bussen",
    motorcycle: "Motor",
    agriculture: "Landbouw",
    construction_machinery: "Grondverzet",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialen",
    brochures: "Brochures",
    price_list: "Prijslijst",
    materials: "Materialen",
    technology: "Technology",
    oe: "OE",
    summer: "Zomer",
    allSeason: "All season",
    winter: "Winter",
    trucks: "Truck",
    season: "Seizoen",
  },
  favoriteProducts: {
    description: "Hier vindt u de producten die u heeft opgeslagen.",
  },
  multiplicator: {
    amountLabel: "Min. aantal banden (*)",
    label: "Multiplicator bonus",
    desc: "Aantal Bridgestone- en Firestone banden. Er is geen bonus in Euro op Firestone banden.",
    goals: {
      loyal: "Loyal",
      bronze: "Brons",
      silver: "Zilver",
      gold: "Goud",
      platinum: "Platina",
    },
    andMore: "en meer",
    chooseTarget: "Selecteer",
    selectTarget: "Selecteer hier uw Jaardoelstelling {year}:",
    multiplication: "Bonus wordt met <b>{factor} vermenigvuldigd</b>",
    minTyres: "<b>Minimaal:</b> {tyre} banden",
  },
  extraFilters: {
    sales_rep_jordy_grimm: "Sales rep: Jordy Grimm",
    sales_rep_marc_pannekoek: "Sales rep: Marc Pannekoek",
    sales_rep_all: "All sales Rep:",
    brand: "Brand:",
    brand_bridgestone: "Bridgestone",
    brand_firestone: "Firestone",
    type_tires: "Type tires:",
    type_pc4: "PC4",
    type_truck: "Truck",
    type_otr: "OTR",
    type_ag: "AG",
    type_mc: "MC",
    type_all: "All",
    year: "Year:",
    month: "Calender Month:",
    distributor_global: "Distributor Global:",
    distributor_intersprint: "Intersprint",
    distributor_van_den_ban: "Van den Ban",
    distributor_reedijk: "Reedijk",
    distributor_wheeltyre: "Wheeltyre",
    distributor_banden_express: "Banden Express",
    distributor_all: "All",
    distributor: "Distributor",
    distributor_tyrenet: "Tyrenet",
    salesRepresentative: "Sales Representative",
  },
  extraEmailSection: {
    description:
      "Extra emailadressen worden uitsluitend gebruikt voor het toesturen van BS+ marketinginformatie en/of financiele informatie en dienen in <b>geen geval voor het inloggen en of beheer</b> van het Bridgestone PLUS account.",
    optionOne: "Voor financiële informatie (o.a. bonusspecificatie)",
    optionTwo:
      "Voor Bridgestone Plus marketingcommunicatie (o.a. acties/nieuwsbrieven)",
    addNewEmail: "Nieuw e-mailadres toevoegen",
  },
  generateReport: {
    title: "Rapport genereren",
    personal_data: {
      title: "Persoonlijke gegevens",
      email: "E-mail",
      salutation: "Aanhef",
      first_name: "Voornaam",
      last_name: "Achternaam",
      job_position: "Functie in het bedrijf",
    },
    shipping_address: {
      title: "Leveringsadres",
      company: "Bedrijfsnaam",
      street: "Huisnummer en straat",
      postal_code: "Postcode",
      mobile_phone: "Mobiele telefoon",
      iban_number: "IBAN",
      vat: "Btw-nummer",
      additional_address: "Aanvullend adres",
      city: "Plaats",
    },
    operating_data: {
      title: "Operationele gegevens",
      customer_number: "Klantnummer",
      group: "Groep",
      first_registration: "Eerste registratie",
      last_login: "Laatste aanmelding",
      tires_per_year: "Banden per jaar",
      over_18_inch: "Meer dan 18 inch",
      premium: "Premium",
      middle: "Middenklasse",
      summer: "Zomer",
      winter: "Winter",
      all_season: "Vier seizoenen",
      totalPoints: "Total Punten",
      major: "Network",
      customer_group: "Network",
    },
    calculated_data: {
      title: "Berekende gegevens",
      tireAmount: "Aantal banden",
      points: "Punten",
      bonus: "Bonus",
    },
    sales_structure: {
      title: "Verkoopstructuur",
      sales_representative: {
        title: "Vertegenwoordiger",
      },
      distributor: {
        title: "Distributeur",
      },
    },
    meta: {
      title: "Metadata",
      brand: {
        title: "Merk",
        none: "",
      },
      tireType: {
        title: "Banden type",
        none: "",
      },
      year: {
        2020: "2020",
        2021: "2021",
        2022: "2022",
        2023: "2023",
        2024: "2024",
        2025: "2025",
        2026: "2026",
        title: "Jaar",
      },
      calendarMonth: {
        title: "Kalendermaand",
        january: "Januari",
        february: "Februari",
        march: "Maart",
        april: "April",
        may: "Mei",
        june: "Juni",
        july: "Juli",
        august: "Augustus",
        september: "September",
        october: "Oktober",
        november: "November",
        december: "December",
      },
    },
    selectAll: "Alles selecteren",
    reset: "Filters resetten",
    generate: "Rapport genereren",
    loadingInfo: "Rapport wordt gegenereerd, even geduld...",
    validation: {
      distributorRequired: "Selecteer minimaal één optie",
    },
  },
};

export default {
  messages,
};
